
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AfterViewInit, Component, HostBinding, HostListener, Inject, OnInit, ViewChild, ViewChildren, QueryList, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, finalize, map, startWith, take, takeUntil } from 'rxjs/operators';
import { AddValueInDropdownComponent } from 'src/app/Dialogs/add-value-in-dropdown/add-value-in-dropdown.component';
import { environment } from 'src/environments/environment';
import { ModalComponent, ModalModel } from '../../../shared/components/modal/modal.component';
import { CategoryAddModel } from '../model/category-add-model';
import { CategoryListModel } from '../model/category-list-model';
import { ItemAddModel } from '../model/item-add-model';
import { ItemEditModel } from '../model/item-edit-model';
import { ItemViewModel } from '../model/item-view-model';
import { ItemBundlesAddModel } from '../model/item_bundles-model';
import { SubCategoryAddModel } from '../model/sub-category-add-model';
import { ItemsService } from '../services/items.service';
import { Subject, Subscription, BehaviorSubject } from 'rxjs';
import { EditContactService } from '../../contact-profile/edit-contact/services/edit-contact.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { Category, SubCategory } from '../items.component';
import { AddSubCategoryComponent } from '../add-sub-category/add-sub-category.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadService } from '../../lead/services/lead.service';
import { FormulaBuilderDialogComponent } from 'src/app/shared/components/formula-builder/formula-builder-dialog.component';
import {
  formulaFieldTypeId,
  isFormulaType,
  isNumberType,
  DISCOUNT_PERCENT_TOKEN,
  variableFromCustomField,
  isReservedFieldName,
  RESERVED_NAMES_SHOWN,
  passesFieldNameRule,
} from 'src/app/shared/formula/formula.types';
import { FormulaRuntimeService } from 'src/app/shared/formula/formula-runtime.service';
import { fieldOwnFormula } from './field-formula';
import { LoggerService } from 'src/app/services/logger.service';
import { CustomFormFieldsComponent } from 'src/app/shared/components/custom-form-fields/custom-form-fields.component';

export interface Comment {
  text: string;
}
declare var $: any;
declare var bootstrap: any;

@Component({
    selector: 'add-edit-item',
    templateUrl: './add-edit-item.component.html',
    styleUrls: ['./add-edit-item.component.scss'],
    providers: [CurrencyPipe] // Add CurrencyPipe to the providers array
    ,
    standalone: false
})

export class AddEditItemComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @HostBinding('class') componentCssClass: any;
  private _unsubscribeAll: Subject<any> = new Subject();
  private _destroyed = false;
  private waitingForCustomFieldsView = false;
  private customFieldsViewSub: Subscription | null = null;
  private customFieldsViewNotifier: Subject<any> | null = null;
  private customFieldsViewStop$ = new Subject<void>();
  private formulaDialogRef: MatDialogRef<FormulaBuilderDialogComponent> | null = null;
  @ViewChild('closeWarehouse') closeWarehouse;
  @ViewChild('closeAddWarehouse') closeAddWarehouse;
  @ViewChild('closeAddUnithouse') closeAddUnithouse;
  @ViewChild('closeAddBundle') closeAddBundle;
  @ViewChildren(CustomFormFieldsComponent)
  customFormFieldsComponents!: QueryList<CustomFormFieldsComponent>;
  @ViewChild('custom', { static: false }) customFormFieldsComponent: any;
  @ViewChild('commentInput') commentInputRef: any;

  /** Flag set to true once the user attempts to submit, so URL error messages appear. */
  urlSubmit = false;

  /**
   * Validator for Website URL and Video Link fields.
   * - Allows empty values (field is optional).
   * - Auto-normalised bare hostnames are accepted after normalizeUrl() runs on blur.
   * - Rejects dangerous schemes (javascript:, data:, vbscript:) even if disguised with
   *   mixed case or extra whitespace.
   * - Requires http or https scheme once a value is present.
   */
  static httpsUrlValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value: string = (control.value || '').trim();
    if (!value) return null; // optional field — empty is fine

    // Block dangerous schemes regardless of casing or leading whitespace
    const lower = value.toLowerCase().replace(/\s/g, '');
    const dangerousSchemes = ['javascript:', 'data:', 'vbscript:'];
    if (dangerousSchemes.some(s => lower.startsWith(s))) {
      return { httpsUrl: true };
    }

    try {
      const url = new URL(value);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return { httpsUrl: true };
      }
    } catch {
      return { httpsUrl: true };
    }
    return null;
  }

  showMe: boolean = false;
  openBulkAction: boolean = false;
  currentIndex: any
  public userMerchants;
  public merchantCurrency;
  filteredCateogry: any;
  filteredSubCateogry: any;
  allCategory: any;
  categoryCount: any;
  filteredSubCategories: any;
  selectCatSubmit: boolean;
  nextItemBtn: any;
  selectedOption: boolean;
  subCategoryId: any;
  priceB: any
  hideOldUi = false;
  toggle() {
    this.showMe = !this.showMe
    // this.hideMe = false
  }

  hideMe: boolean = false;
  show() {
    this.hideMe = !this.hideMe
  }

  myImage: HTMLImageElement[] = []

  addOnBlur = true;
  readonly separatorKeyCodes = [ENTER, COMMA] as const;

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.comments.push({ text: value });
    }

    if (event.input) {
      event.input.value = '';
    }
  }
  remove(comment: Comment): void {
    const index = this.comments.indexOf(comment);
    if (index >= 0) {
      this.comments.splice(index, 1);
    }
  }

  public hidePrice: boolean;
  public trackInv: boolean;
  public outOfStoc: boolean;
  userBasicInfoForm: FormGroup;
  editItemCodeForm: FormGroup;
  editItemBundleForm: FormGroup;
  itemDiscountForm: FormGroup;
  itemPriceForm: FormGroup;
  itemValueForm: FormGroup;
  addNewUnitForm: FormGroup;
  newWarehouseForm: FormGroup;
  itemwarehouseListForm: FormGroup;
  addNewItemBundle: FormGroup;
  asignUser: FormGroup;
  addNewTexListForm: FormGroup;
  itemPriceTaxForm: FormGroup;
  unitSelection: FormGroup;
  numberField: FormGroup;
  enableInput: boolean = false
  public advanceUnitCal: boolean;
  categoryAddModel = new CategoryAddModel();
  subCategoryAddModel = new SubCategoryAddModel();
  categoryListModel = new CategoryListModel();
  itemAddModel = new ItemAddModel();
  itemViewModel: ItemViewModel;
  itemEditModel = new ItemEditModel();
  itemBundlesAddModel = new ItemBundlesAddModel();
  public imageUrl = environment.IMAGE_BACKET_URL;
  public profitMargn: any = 0
  public selectedCurrency: any = "";
  // advance Calculations
  calculations = {
    height: 0,
    width: 0,
    result: "0",
    sign: "+",
  }
  signsArray = ['+', "-", "x", "/"];
  // advance Calculations ends 
  subscriptions: Subscription[] = [];
  crSymbol; // currency symbol
  crCode; // currency code
  constructor(
    private fb: FormBuilder,
    private formBuilder: FormBuilder,
    private itemsService: ItemsService,
    private spinnerService: NgxSpinnerService,
    private translateService: TranslateService,
    public dialog: MatDialog,
    config: NgbModalConfig,
    private editContactService: EditContactService,
    public overlayContainer: OverlayContainer,
    public currencyPipe: CurrencyPipe,
    public dialogRef: MatDialogRef<ModalComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public inputData: any,
    private decimalPipe: DecimalPipe,
    private snackbar: MatSnackBar,
    public leadService: LeadService,
    private formulaRuntime: FormulaRuntimeService,
    private logger: LoggerService,

  ) {
    config.backdrop = 'static';
    config.keyboard = false;
    let theme = window.localStorage.getItem("theme")
    if (theme) {
      this.onSettheme(theme)
    } else {
      this.onSettheme("ligth-theme")
    }
    this.unitSelection = new FormGroup({
      unitList1: new FormControl('Area')
    });
    this.numberField = new FormGroup({
      numberValue: new FormControl(1, Validators.min(1))
    })
    this.isUserSearching = false
  }
  @ViewChild('content', { static: false }) modal;
  public onSettheme(e: string) {
    this.overlayContainer.getContainerElement().classList.add(e);
    this.componentCssClass = e;
    window.localStorage.setItem("theme", e);
  }
  serchArr: any = {};
  cateogryListArr: any;
  itemListEditArr: any;
  bundleListArr: any;
  firstUrlTitle: any;
  secondUrlTitle: any;
  minPrice: any;
  addDiscountsArr = [];
  addPriceArr = [];
  warehouseListArr: any;
  taxListArr: any = [];
  unitListArr: any;
  files: any;
  lengthChar = false;
  userBasicInfoSubmit = false;
  itemCodeSubmit = false;
  itemBundleSubmit = false;
  itemPriceSubmit = false;
  itemDiscountSubmit = false;
  itemPriceTaxSubmit = false;
  itemValueSubmit = false;
  itemWarehouseListSubmit = false;
  itemWarehouseSubmit = false;
  itemUnitSubmit = false;
  itemAddBundleSubmit = false;
  mainImageUrl: any;
  cateogryName: any;
  addItemPriceTaxArr = [];
  addEditItemCodeArr = [];
  itemAdditionalDetailsArr = [];
  addItemAdditionalDetailsArr = [];
  itemBundles = [];
  addWarehouseArr = [];
  warehouseNameListArr = [];
  itemAdditionalDetailsArrList = [];
  subCategoryListArr: any;
  mainImage: any;
  image: any = "";
  symbols: any;
  unit: any;
  symbolsList: any;
  passMust = false;
  isDeactivated: boolean = false;
  isChecked: boolean = false;
  getcateogryName: any;
  isCheckedItems: boolean = false
  filteredCategories: any;
  currenciesListArr: any;
  itemsEditButton: any;
  itemsImages: any;
  userCurrency: any
  sales_commission_type: any;
  saleTax: boolean = false
  merchent: any;
  editItemsImages = [];
  selectedBundle = [];
  user: string = "";
  pass1Checked = false;
  saveTexas: any = [];
  categoryItemFlag = false;
  itemImage = Array();
  customDataFieldViewData = []
  private customFieldLoadState = { definitions: false, itemValues: false };
  private customFieldFlagsSynced = false;
  itemPriceA: any;
  // for item labeling prices
  alphabetArray: any = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
  // to calculate profit
  profit: number = 0
  // to add comments
  comments: any = []
  // used for material chips
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  unitList = [{ name: 'Area' }];
  filteredItems: any
  selectedItemId: number
  currentTabIndex: number = 0
  filteredCurrency: any
  filteredWareHouses: any
  userSearch: FormControl = new FormControl();
  itemsQuantity: FormControl = new FormControl();
  unitSelect: FormControl = new FormControl();
  inventory: FormControl = new FormControl(0);
  itemType: FormControl = new FormControl('Product');
  wareHouseSearch: FormControl = new FormControl();
  cateogrySearch: FormControl = new FormControl();
  subCateogrySearch: FormControl = new FormControl();
  searchItemCode: FormControl = new FormControl();
  public isUserSearching: boolean;
  filterValue = ''
  categorySearchHistory: any[] = [];
  infoItemBlock = false;
  hiddenInfo = false;
  categoryId: any
  languageName: any;
  englishPanelExpanded: boolean = false;
  spanishPanelExpanded: boolean = false;
  frenchPanelExpanded: boolean = false;
  itemPriceList: any;
  categoryName: any;
  allTaxesList: any;
  subCategoryName: any;
  newItemPriceList: any = { pricesA: '', pricesB: '', pricesC: '', pricesD: '' };
  selectedPrice: any;
  newPrice = new FormControl('');
  async ngOnInit(): Promise<void> {
    this._destroyed = false;
    this.retireCustomFieldsViewSub();
    this.customFieldLoadState = { definitions: false, itemValues: false };
    // A new product has no saved values to wait for: without this the "both sources loaded" sync
    // never ran, so existing Formula fields showed no Apply switch and posted no recipe.
    if (this.inputData?.id == null) {
      this.customFieldLoadState.itemValues = true;
    }
    this.copiedFormulaFieldIds.clear();
    this.customFieldFlagsSynced = false;
    this.ensureUnsubscribeSubject();

    let loginUserValue: any;
    try {
      loginUserValue = JSON.parse(localStorage.getItem('loginUserValue'));
    } catch (err) {
      this.logger.log('formula:loginUserValue parse error', err?.message || 'parse failed');
      loginUserValue = null;
    }
    this.languageName = loginUserValue?.languages?.name
    this.initializeExpansionPanels();
    this.addToNgOninit();
    this.getCateogryList(

    ).then(() => {
      this._autoCompleteSearchControlForCategory();
      this._autoCompleteSearchControlForSubCategory();
    });

    // this.listArr();
    this.itemBasicInfoFormVal();
    this.getCurrenciesList().then((val) => {
      // this._autoCompleteSearchControlForCurrency()

    })
    this.getWarehouseList().then((item) => {
      this._autoCompleteSearchControlForWareHouses()
    });
    this.userCustomUrl()
    this.salesCommType('2');
    this.getItemListEdit(this.inputData.categoryId).then((itemList) => {
      this.itemsEditButton = this.inputData.itemsEditButtonId;
      this._autoCompleteSearchControlForItemsCode()
    });
    this.calculateProfit()
    if (this.inputData?.edit == 'quote' || this.inputData?.edit == 'quotes') {
      this.userBasicInfoForm.get('name').setValue(this.inputData?.name)
      this.itemAddModel.name = this.inputData?.name

      this.isDeactivated = true
    }
    const initialComments = this.inputData?.comments || this.inputData?.Comments || this.inputData?.fruits;
    if (initialComments && !this.comments?.length) {
      if (typeof initialComments === 'string') {
        try {
          this.comments = JSON.parse(initialComments);
        } catch {
          this.comments = [{ title: initialComments, status: 2 }];
        }
      } else if (Array.isArray(initialComments)) {
        this.comments = initialComments.map((c: any) => ({
          title: typeof c === 'string' ? c : (c?.title || c?.item_comments || c?.name || ''),
          status: 2,
          ...(typeof c === 'object' ? c : {})
        })).filter((c: any) => c.title);
      }
    }
    await this.getTaxList();
    await this.getUnitList();
    if (!this._destroyed) {
      this.applyFormulaTogglesWhenViewReady();
    }
  }

  private ensureUnsubscribeSubject(): Subject<any> {
    if (this._destroyed) {
      // After ngOnDestroy: never resurrect a teardown subject. takeUntil on this one ends the
      // subscription at once (BehaviorSubject emits on subscribe).
      return new BehaviorSubject<any>(true);
    }
    if (!this._unsubscribeAll.closed) {
      return this._unsubscribeAll;
    }
    this.retireCustomFieldsViewSub();
    this.subscriptions.forEach((sub) => sub?.unsubscribe());
    this.subscriptions = [];
    this._unsubscribeAll = new Subject();
    return this._unsubscribeAll;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.imageFilesAddedEdit(changes)
  }
  /**
   * Actively listen to To field and filter items array on type or change value
   */

  _autoCompleteSearchControlForCurrency(): void {
    let currency = this._filterCurrency(this.userSearch.value);

    this.filteredCurrency = currency;
    // this.filteredCurrency = this.userSearch.valueChanges.pipe(
    //   // startWith(''),
    //   map((currency:any) => {this._filterCurrency(currency);
    //   console.log("iiiiiiiiiiiiiiiiiiiiiiiii,currency",currency);
    //   } )
    //   )
  }
  /**
   * Filtered items on item codes
   */
  private _filterCurrency(filterValue: string): any[] {
    delete this.itemAddModel.currency_id
    if (filterValue) { return this.currenciesListArr?.filter(item => (item.currency_code?.toLowerCase()).includes(filterValue?.toLowerCase()) || item.currency_symbol == filterValue?.toLowerCase()) }
    else {
      return this.currenciesListArr;
    }
  }
  /**
    * Actively listen to To field and filter items array on type or change value
    */

  //  private _filterSubCateogry(): void {
  //   this.filteredSubCateogry = this.subCateogrySearch.valueChanges.pipe(
  //     startWith(''),
  //     map((subCateogry:any) => this.filterSubCateogry(subCateogry))
  //   )
  //  }

  private _autoCompleteSearchControlForSubCategory(): void {
    this.filteredSubCategories = this.subCateogrySearch
      .valueChanges.pipe(
        startWith(''),
        map((subCategory: any) => this._filterSubCategory(subCategory))

      );
    // this.cd.detectChanges()
  }
  private _filterSubCategory(value: string): SubCategory[] {
    const filterValue = value?.toLowerCase();
    if (filterValue)
      return this.subCategoryListArr?.filter((subCategory) =>
        subCategory.name?.toLowerCase().includes(filterValue)
      );
    return this.subCategoryListArr;
  }

  changeMyControl(event): void {
    const item = this.cateogryListArr?.find(
      (state) => state.name?.toLowerCase() === event.target.value?.toLowerCase()
    );
    if (!item) {
      this.selectedOption = false;
    }
  }

  selectCategoryModalFuc() {

  }
  getCatId(id) {
    this.categoryId = id;
    this.getCateogryName(id);
    return this.getSubCategoryList();
  }
  // selectCategoryFuc(id =null) {

  //   // Check User Basic Info Validation
  //   if (this.userBasicInfoForm.get('categoryId').invalid) {
  //     return;
  //   } else {
  //     // Check User Basic Info Validation

  //       this.itemAddModel.categoryId = id?id: this.cateogryListArr.find((item=>item.name == this.userBasicInfoForm.get('categoryId').value.categoryId))?.id
  //       console.log(this.itemAddModel.categoryId,'dddddddd')
  //       this.getCateogryName(this.itemAddModel.categoryId);
  //       this.nextItemBtn.nativeElement.click();
  //       this.getSubCategoryList().then((res:any)=>{
  //         this._autoCompleteSearchControlForSubCategory()
  //       });
  //   }
  // }

  getSubCategoryList() {
    return new Promise((resolve, reject) => {
      this.serchArr = {
        "filter": { "categoryId": this.categoryId }
      }
      const subCategorySearchSubs = this.itemsService.subCategorySearch(this.serchArr).subscribe(res => {
        if (res.message === 'success' || res.status === 1) {
          this.subCategoryListArr = res.data;
          if (this.itemAddModel.subCategoryId) {
            this.subCategoryListArr.map(x => {
              if (x.id == this.itemAddModel.subCategoryId) {
                this.subCategoryName = x.name
              }

            })
          }
          this._autoCompleteSearchControlForSubCategory()
          this.spinnerService.hide();
          resolve(this.subCategoryListArr)
        } else {
          this.spinnerService.hide();
          reject()
        }
      });
      this.subscriptions.push(subCategorySearchSubs);
    })

  }

  //  private filterSubCateogry(filterValue: string): any[] {
  // if(filterValue) return this.subCategoryListArr?.filter(subCatList => (subCatList.name?.toLowerCase()).includes(filterValue?.toLowerCase()));
  //  return this.subCategoryListArr;
  // }

  async getCateogryList(body: any = '') {
    return new Promise((resolve, reject) => {
      const cateogryListSubs = this.itemsService.cateogryList(body).subscribe((res) => {
        this.cateogryListArr = res.data;
        if (this.inputData.categoryId) {
          this.cateogryListArr.map(x => {
            if (x.id == this.inputData.categoryId) {
              this.categoryName = x.name

            }
          })
        }
        this.allCategory = res.totalCount;
        this.spinnerService.hide();
        resolve(this.cateogryListArr);
      });
      this.subscriptions.push(cateogryListSubs);
    });
  }

  private _filterCateogry(): void {
    this.filteredCateogry = this.cateogrySearch.valueChanges.pipe(
      startWith(''),
      map((cateogry: any) => this._filterCategory(cateogry))
    )
  }

  private filterCateogry(filterValue: string): any {
    if (filterValue) return this.cateogryListArr?.filter(obj => (obj.name?.toLowerCase()).includes(filterValue?.toLowerCase()));
    return this.cateogryListArr;
  }
  private _autoCompleteSearchControlForWareHouses(): void {

    this.filteredWareHouses = this.wareHouseSearch.valueChanges.pipe(
      startWith(''),
      map((warehouse: any) => this._filterWareHouses(warehouse))
    )
  }
  /**
   * Filtered items on item codes
   */
  private _filterWareHouses(filterValue: string): any[] {
    // delete this.itemAddModel.currency_id
    if (filterValue) return this.warehouseListArr?.filter(item => (item.name?.toLowerCase()).includes(filterValue?.toLowerCase()));
    return this.warehouseListArr;
  }


  onSelectCurrency(id, symbol) {
    this.itemAddModel.currency_id = id
    this.selectedCurrency = symbol

  }
  async listArr() {
    await this.getBundleIdList();

    this.itemsEditButton = this.inputData.itemsEditButtonId;
    this.getSubCategoryList()
    await this.getTaxList();
    await this.getUnitList();
  }

  changeImage(index, id) {
    this.image = this.editItemsImages[index];
    this.mainImageUrl = id;
  }

  onEditSHowMainImage(image) {
    this.image = image;
  }

  get f(): { [key: string]: AbstractControl } {
    return this.userBasicInfoForm.controls;
  }
  get itemCode(): { [key: string]: AbstractControl } {
    return this.editItemCodeForm.controls;
  }
  get itemBundle(): { [key: string]: AbstractControl } {
    return this.editItemBundleForm.controls;
  }
  get itemPrice(): { [key: string]: AbstractControl } {
    return this.itemPriceForm.controls;
  }
  get itemDiscount(): { [key: string]: AbstractControl } {
    return this.itemDiscountForm.controls;
  }
  get itemPriceTax(): { [key: string]: AbstractControl } {
    return this.itemPriceTaxForm.controls;
  }
  get itemValue(): { [key: string]: AbstractControl } {
    return this.itemValueForm.controls;
  }
  get itemWarehouses(): { [key: string]: AbstractControl } {
    return this.itemwarehouseListForm.controls;
  }
  get newWarehouses(): { [key: string]: AbstractControl } {
    return this.newWarehouseForm.controls;
  }
  get newUnit(): { [key: string]: AbstractControl } {
    return this.addNewUnitForm.controls;
  }
  get newBundle(): { [key: string]: AbstractControl } {
    return this.addNewItemBundle.controls;
  }
  get unitLists(): { [key: string]: AbstractControl } {
    return this.unitSelection.controls;
  }

  /**
   * Actively listen to To field and filter items array on type or change value
   */

  private _autoCompleteSearchControlForItemsCode(): void {

    this.filteredItems = this.searchItemCode.valueChanges.pipe(
      startWith(''),
      map((category: any) => this._filterItems(category))
    )
  }
  /**
   * Filtered items on item codes
   */
  private _filterItems(filterValue: string): any[] {

    if (filterValue) return this.itemListEditArr?.filter(item => item.name?.toLowerCase().includes(filterValue?.toLowerCase()) || item.code == filterValue);
    return this.itemListEditArr;
  }
  /**
   * To save selected item id
   */
  onSelectedOption(itemId) {
    this.selectedItemId = itemId
  }
  getItemListEdit(id = null): Promise<any> {
    return new Promise((resolve, reject) => {
      const itemSearchSubs = this.itemsService.itemSearch({ ...this.serchArr, hideLoader: true }).subscribe(val => {
        if (val.message === 'success' || val.status === 1) {
          this.itemList()
          this.itemListEditArr = val.data;
          resolve(this.itemListEditArr)
          this.spinnerService.hide();
        }
      });
      this.subscriptions.push(itemSearchSubs);
    })

  }
  increment() {
    this.itemwarehouseListForm.setValue({
      item_warehouses: this.itemwarehouseListForm.get('item_warehouses').value,
      items: this.itemwarehouseListForm.get('items').value + 1
    });
  }

  decrement() {
    if (this.itemwarehouseListForm.get('items').value > 0) {
      this.itemwarehouseListForm.setValue({
        item_warehouses: this.itemwarehouseListForm.get('item_warehouses').value,
        items: this.itemwarehouseListForm.get('items').value - 1
      });
    }


  }
  async removeCategory(i, categoryId, obj) {
    const dialogData = new ModalModel(
      this.translateService.instant('PROFILE.CONFIRMDELETE')
    );
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '450px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        const removeCategoryValueSubs = this.itemsService
          .removeCategoryValue({ id: categoryId })
          .subscribe((val: any) => {
            if (obj == 'category') {
              this.cateogryListArr.splice(i, 1);
              this._autoCompleteSearchControlForCategory()
              this.getSearchHistory().then((res: any) => {
                this.categorySearchHistory = res;
                this.infoItemBlock = false;
                this.hiddenInfo = true;
              });

            }
          });
        this.subscriptions.push(removeCategoryValueSubs);
      }
    });
  }

  async editCustomCategory(obj) {
    const dialogRef = this.dialog.open(AddCategoryComponent, {
      width: "800px",
      data: obj
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        this.userBasicInfoForm.patchValue({
          categoryId: dialogResult?.data?.name
        })
      }
      this.getCateogryList().then(() => {
        this._autoCompleteSearchControlForCategory()

      })
    });
  }

  async getSearchHistory() {
    return new Promise((resolve, reject) => {
      const getSearchListSubs = this.itemsService.getSearchList().subscribe(res => {
        this.spinnerService.hide();
        resolve(res.data)

      });
      this.subscriptions.push(getSearchListSubs);
    })

  }

  private _autoCompleteSearchControlForCategory(): void {
    this.filteredCategories = this.cateogrySearch
      .valueChanges.pipe(
        startWith(''),
        debounceTime(1000),
        map((category: any) => this._filterCategory(category))
      );

    const filteredCategoriesSubs = this.filteredCategories.subscribe((item) => {
      if (item?.length > 0 && this.filterValue) {
        let itemData = item[0]
        const searchFound = this.categorySearchHistory?.find((historyItem) => historyItem.id === itemData.id);
        if (!searchFound) {
          const createCategorySearchHistorySubs = this.itemsService
            .createCategorySearchHistory({
              item,
            })
            .subscribe((res) => {
              this.categorySearchHistory = res.data;
            });
          this.subscriptions.push(createCategorySearchHistorySubs);
        }
      }
    });
    this.subscriptions.push(filteredCategoriesSubs);
  }

  private _filterCategory(value: string): Category[] {
    this.filterValue = value?.toLowerCase();
    if (this.filterValue)
      return this.cateogryListArr?.filter((state) =>
        state.name.toLowerCase().includes(this.filterValue)
      );
    return this.cateogryListArr;
  }

  increments() {
    this.numberField.setValue({
      numberValue: this.numberField.get('numberValue').value + 1
    });
  }
  decrements() {
    const currentValue = this.numberField.get('numberValue').value;
    if (currentValue > 1) {
      this.numberField.setValue({
        numberValue: currentValue - 1
      });
    }
  }

  /**
   * To save first url title
   */
  changeAddField(event, type) {
    if (type == 'addTitle') {
      this.firstUrlTitle = event.target.value
    }
  }
  /**
   * To hide and show input field for urls title
   */
  editAddField(num) {
    $("#editButton" + num).addClass("d-none");
    $("#AddressTitle" + num).addClass("d-none");
    $("#AddressTitleInput" + num).removeClass("d-none");
    $("#checkButton" + num).removeClass("d-none");
  }
  /**
    * To hide and show input field for urls title
    */
  saveAddField(num) {
    $("#editButton" + num).removeClass("d-none");
    $("#AddressTitle" + num).removeClass("d-none");
    $("#AddressTitleInput" + num).addClass("d-none");
    $("#checkButton" + num).addClass("d-none");
  }
  /**
    * To save second url title
    */
  changeSecondUrlField(event, type) {
    if (type == 'addTitle') {
      this.secondUrlTitle = event.target.value
    }
  }

  itemList() {
    this.itemAddModel.categoryId = this.inputData.categoryId;
    if (this.inputData.subCategoryId) {
      this.itemAddModel.subCategoryId = this.inputData.subCategoryId;
    } else if (this.inputData.categoryId && this.inputData.id) {
      this.editItemList();
    }
  }

  getCurrenciesList() {
    return new Promise((resolve, reject) => {
      const currenciesListSubs = this.itemsService.currenciesList({ hideLoader: true }).subscribe(val => {
        if (val.message === 'success' || val.status === 1) {
          this.currenciesListArr = val.data;
          this.filteredCurrency = val.data;
          this.sortOn(this.currenciesListArr, "currency_code");
          this.userMerchants = JSON.parse(localStorage.getItem('user_merchants'));
          this.merchantCurrency = this.userMerchants[0].merchant_default_currencies[0].currencies?.id
          this.userCurrency = this.currenciesListArr.find(value => value.id == this.merchantCurrency)
          // this.userBasicInfoForm.get('currency_id')?.setValue(this.userCurrency.id)
          this.addCurrencyDefault();


          resolve(true)
        }
      });
      this.subscriptions.push(currenciesListSubs);
    })

  }

  addCurrencyDefault() {
    this.leadService.currencySymbal$.subscribe((res: any) => { this.crSymbol = res });
    this.leadService.currencyCode$.subscribe((res: any) => { this.crCode = res });
    const matchingCurrency = this.filteredCurrency.find(
      currency =>
        currency.currency_code === this.crCode
    );

    this.selectedCurrency = { currency_code: matchingCurrency.currency_code, currency_symbol: matchingCurrency.currency_symbol };
    if (this.filteredCurrency.length > 0) {
      this.selectedCurrency = this.filteredCurrency.find(x => x.currency_code == this.selectedCurrency?.currency_code);
      this.userBasicInfoForm.get('currency_id')?.setValue(this.selectedCurrency.id);
    }
  }

  // Sorts an array of objects "in place". (Meaning that the original array will be modified and nothing gets returned.)
  sortOn(arr, prop) {
    arr.sort(
      function (a, b) {
        if (a[prop] < b[prop]) {
          return -1;
        } else if (a[prop] > b[prop]) {
          return 1;
        } else {
          return 0;
        }
      }
    );
  }

  /**
   * remove values from chips
   */
  removeComment(comments) {
    const index = this.comments.indexOf(comments);
    if (index >= 0) {
      this.comments.splice(index, 1);
    }
  }
  /**
   * add comments in comments array
   */
  addComment(event: MatChipInputEvent) {
    const value = (event.value || '').trim();
    // Add comment
    if (value) {
      this.comments.push({ title: value, status: 2 });
    }
    // Clear the input value
    event.input.value = '';
  }

  /**
   * Add comment from input field (for saved comments section)
   */
  addCommentFromInput(inputElement: HTMLInputElement): void {
    if (!inputElement) return;
    const value = (inputElement.value || '').trim();
    if (value && value.length > 0) {
      // Check if comment already exists to avoid duplicates
      const exists = this.comments.some(comment => comment.title === value);
      if (!exists) {
        this.comments.push({ title: value, status: 2 });
      }
      inputElement.value = '';
    }
  }

  flushPendingComments(inputEl?: any): void {
    const el = inputEl || this.commentInputRef?.nativeElement;
    if (el) {
      this.addCommentFromInput(el);
    }
  }

  /**
   * Select a saved comment (optional - can be used to insert into input or perform other actions)
   */
  selectSavedComment(comment: any): void {
    // You can implement logic here if needed, e.g., insert into main input field
    // For now, this is just a placeholder
  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }


  updateSubcatId(id) {

    this.itemAddModel.subCategoryId = id;
  }

  getCateogryName(id) {
    if (this.cateogryListArr) {
      this.cateogryListArr.forEach((value) => {
        if (value.id == id) {
          this.getcateogryName = value.name;
        }
      });
    }
  }

  getBundleIdList() {
    const bundleListSubs = this.itemsService.bundleList().subscribe(res => {
      this.bundleListArr = res.data;
    });
    this.subscriptions.push(bundleListSubs);
  }

  addItemPriceTax(data: any = '') {
    this.itemPriceTaxSubmit = true;
    let newItem
    if (data !== '') {
      newItem = data
    } else {
      if (this.itemPriceTaxForm.invalid) {
        this.saleTax = true;
        return;
      }

      newItem = this.itemPriceTaxForm.value;

    }

    const existingIndex = this.addItemPriceTaxArr.findIndex(item => item?.name === newItem?.name);

    if (existingIndex !== -1) {
      // Update the existing item's taxe_value        
      this.addItemPriceTaxArr[existingIndex].taxe_value = newItem?.taxe_value;
    } else {
      // Add the new item if it doesn't already exist
      this.addItemPriceTaxArr.push(newItem);
    }

    // Sorting the array
    this.addItemPriceTaxArr.sort((a, b) => a.taxe_value - b.taxe_value); // b - a for reverse sort

    // Resetting the form and submit flag
    this.itemPriceTaxSubmit = false;
    if (data !== '') {

    } else {
      this.itemPriceTaxForm.reset();
      this.enableInput = false

    }
  }


  addWarehouseList() {
    this.itemWarehouseListSubmit = true;
    if (this.itemwarehouseListForm.invalid) {
      return;
    }

    const addNewWarehouseSubs = this.itemsService.addNewWarehouse({ name: this.itemwarehouseListForm.get('item_warehouses').value, status: 1 }).subscribe(
      res => {
        if (res.data) {
          this.addWarehouseArr.push({ warehouseId: res.data.id, items: this.itemwarehouseListForm.get('items').value, status: 2, name: this.itemwarehouseListForm.get('item_warehouses').value })
          this.itemwarehouseListForm.reset();

        }
        // this.getWarehouseList()
        this.getWarehouseList().then((item) => {
          this._autoCompleteSearchControlForWareHouses()
        });
      });

    this.subscriptions.push(addNewWarehouseSubs);
    this.closeWarehouse.nativeElement.click();

    this._autoCompleteSearchControlForWareHouses()
    this.warehouseNameListArr = this.addWarehouseArr;

  }

  addDiscounts() {
    this.itemDiscountSubmit = true;
    if (this.itemDiscountForm.invalid) {
      return;
    }
    if (!this.itemDiscountForm.get('discounts').value) {
      return
    }
    const discountValue = parseFloat(this.itemDiscountForm.get('discounts').value);
    if (!isNaN(discountValue) && discountValue <= 100) {
      this.addDiscountsArr.push(this.itemDiscountForm.value);
    } else {
      this.snackbar.open(this.translateService.instant('Snackbar.Discount should be equal or less than 100'), this.translateService.instant('COMMON.Close'), {
        duration: 3000, // duration in milliseconds
        verticalPosition: 'top', // or 'bottom'
        horizontalPosition: 'center' // or 'left', 'right'
      });
    }
    this.addDiscountsArr.sort((a, b) => a.discounts - b.discounts); // b - a for reverse sort

    this.itemDiscountSubmit = false;
    this.itemDiscountForm.reset();
  }

  // addPrice() {
  //   if (this.itemPriceForm.invalid) {
  //     return
  //   }
  //   if (Number(this.itemPriceForm.value.pricesA) < Number(this.minPrice)) {
  //     this.itemPriceForm.controls.pricesA.setErrors({ min: true });
  //     return
  //   }
  //   this.calculateProfit()
  //   this.itemPriceSubmit = false;
  //   this.itemPriceForm.reset();
  // }
  calculateProfit() {
    const value = this.userBasicInfoForm.get('fix_cost_per_unit')?.value || '0';
    const fix_cost_per_unit = parseFloat(value.toString().replace(/,/g, '')) || 0;

    const priceAString = this.itemPriceForm.get('pricesA')?.value;
    if (typeof priceAString === 'string' || typeof priceAString === 'number') {
      const priceA = parseFloat(priceAString.toString().replace(/,/g, '')) || 0;

      if (fix_cost_per_unit || priceA) {
        let profit = priceA - fix_cost_per_unit;
        let profitMargin = ((profit * 100) / priceA).toFixed(2);

        const sales_commission = parseFloat(this.userBasicInfoForm.get('sales_commission')?.value) || 0;
        const sales_commission_type = this.sales_commission_type != null ? String(this.sales_commission_type) : '2'; // '1' = fixed, '2' = percentage

        if (sales_commission > 0 && (sales_commission_type === '1' || sales_commission_type === '2')) {
          if (sales_commission_type === '2') {
            // Commission is percentage of total sale
            const commissionAmount = (priceA * sales_commission) / 100;
            profit = priceA - fix_cost_per_unit - commissionAmount;
          } else {
            // Commission is a fixed amount
            profit = priceA - fix_cost_per_unit - sales_commission;
          }

          profitMargin = ((profit * 100) / priceA).toFixed(2);
        }

        this.profit = profit;
        this.profitMargn = profitMargin;
      } else {
        this.profit = 0;
        this.profitMargn = 0;
      }
    } else {
      this.profit = 0;
      this.profitMargn = 0;
    }
  }

  /**
   * Validates all four price fields (Prices A, B, C, D) against the Minimum Price.
   * If any provided price is less than Minimum Price, sets the { min: true } error
   * on that specific price control and on the minimum price control.
   */
  minPriceViolatedPrices: string = '';

  validatePricesAgainstMinPrice(): void {
    let minPriceValue = 0;
    const rawMin = this.userBasicInfoForm?.get('min_price')?.value;
    if (rawMin !== null && rawMin !== undefined && rawMin !== '') {
      minPriceValue = parseFloat(rawMin.toString().replace(/,/g, '')) || 0;
    }

    const priceConfigs = [
      { key: 'pricesA', labelKey: 'ITEMS.Price A' },
      { key: 'pricesB', labelKey: 'ITEMS.Price B' },
      { key: 'pricesC', labelKey: 'ITEMS.Price C' },
      { key: 'pricesD', labelKey: 'ITEMS.Price D' },
    ];

    const violatingLabels: string[] = [];

    priceConfigs.forEach(({ key, labelKey }) => {
      const control = this.itemPriceForm?.get(key);
      if (!control) return;
      const rawVal = control.value;
      if (rawVal !== null && rawVal !== undefined && rawVal !== '') {
        const numericVal = parseFloat(rawVal.toString().replace(/,/g, ''));
        if (!isNaN(numericVal)) {
          if (numericVal < minPriceValue) {
            const existingErrors = control.errors || {};
            control.setErrors({ ...existingErrors, min: true });
            violatingLabels.push(this.translateService.instant(labelKey));
          } else {
            if (control.errors?.min) {
              const { min, ...remainingErrors } = control.errors;
              control.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
            }
          }
        }
      } else {
        if (key !== 'pricesA' && control.errors?.min) {
          const { min, ...remainingErrors } = control.errors;
          control.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
        }
      }
    });

    this.minPriceViolatedPrices = violatingLabels.join(', ');

    const minControl = this.userBasicInfoForm?.get('min_price');
    if (minControl) {
      if (violatingLabels.length > 0) {
        const existingErrors = minControl.errors || {};
        minControl.setErrors({ ...existingErrors, min: true });
      } else {
        if (minControl.errors?.min) {
          const { min, ...remainingErrors } = minControl.errors;
          minControl.setErrors(Object.keys(remainingErrors).length ? remainingErrors : null);
        }
      }
    }

    this.calculateProfit();
  }








  addBundle() {
    this.itemBundleSubmit = true;
    if (this.editItemBundleForm.invalid) {
      return;
    }
    this.selectedBundle.push(this.editItemBundleForm.value)
    this.itemBundleSubmit = false;
    this.editItemBundleForm.reset();
  }


  onBlur(inputValue: string, type) {
    const numericRegex = /^(\d*\.?\d*)$/;
    const numericValue = parseFloat(inputValue.replace(/[$,]/g, ''));
    if (isNaN(numericValue)) {
      if (type == 'priceA') {
        this.itemPriceForm.get('pricesA').setValue('');
      }
      else if (type == 'priceB') {
        this.itemPriceForm.get('pricesB').setValue('');

      }
      else if (type == 'priceC') {
        this.itemPriceForm.get('pricesC').setValue('');

      }
      else if (type == 'priceD') {
        this.itemPriceForm.get('pricesD').setValue('');

      }
      else if (type == 'fix_cost_per_unit') {
        this.userBasicInfoForm.get('fix_cost_per_unit').setValue('');
      }
    }
    if (!isNaN(numericValue)) {
      let formattedCurrency = this.currencyPipe.transform(numericValue, 'USD', '', '1.2-2');
      if (type == 'priceA') {
        if (!numericRegex.test(inputValue)) {
          // If the input value does not match the numeric regex, clear the value in the form control
          this.itemPriceForm.get('pricesA').setValue('');
        }
        this.itemPriceForm.get('pricesA').setValue(formattedCurrency);

      }
      else if (type == 'priceB') {
        if (!numericRegex.test(inputValue)) {
          // If the input value does not match the numeric regex, clear the value in the form control
          this.itemPriceForm.get('pricesB').setValue('');
        }
        this.itemPriceForm.get('pricesB').setValue(formattedCurrency);

      }
      else if (type == 'priceC') {
        if (!numericRegex.test(inputValue)) {
          // If the input value does not match the numeric regex, clear the value in the form control
          this.itemPriceForm.get('pricesC').setValue('');
        }
        this.itemPriceForm.get('pricesC').setValue(formattedCurrency);

      }
      else if (type == 'priceD') {
        if (!numericRegex.test(inputValue)) {
          // If the input value does not match the numeric regex, clear the value in the form control
          this.itemPriceForm.get('pricesD').setValue('');
        }
        this.itemPriceForm.get('pricesD').setValue(formattedCurrency);

      }
      else if (type == 'fix_cost_per_unit') {
        if (!numericRegex.test(inputValue)) {
          // If the input value does not match the numeric regex, clear the value in the form control
          this.userBasicInfoForm.get('fix_cost_per_unit').setValue('');
        }
        this.userBasicInfoForm.get('fix_cost_per_unit').setValue(formattedCurrency);
      }
    } else {
      console.error('Invalid currency value:', inputValue);
    }
  }


  //   onInputChange(event: any) {
  //     const input = event.target as HTMLInputElement;
  //     const inputValue = input.value;
  //     // Regular expression to allow only numbers (including decimals)
  //     const numericRegex = /^(\d*\.?\d*)$/;

  //     if (!numericRegex.test(inputValue)) {
  //       // If the input value does not match the numeric regex, reset the value to empty
  //       input.value = '';
  //     }
  //   }


  addEditItemcode() {
    this.itemCodeSubmit = true;
    if (!this.editItemCodeForm.get('item_code').value) {
      return;
    }
    this.addEditItemCodeArr.push({ id: this.selectedItemId, code: this.editItemCodeForm.value.item_code });
    this.editItemCodeForm.value.item_code = '';
    this.itemCodeSubmit = false;
    this.editItemCodeForm.reset();
  }

  addItemAdditionaldetails() {
    this.itemValueSubmit = true;
    if (this.itemValueForm.invalid) {
      return;
    }
    let additionalValues = this.itemValueForm.value
    let value = {
      value: additionalValues.value,
      unit_id: additionalValues.unit_id ? additionalValues.unit_id.unit_id : '',
      unit_name: additionalValues.unit_id ? additionalValues.unit_id.unit_name : ''
    }
    this.addItemAdditionalDetailsArr.push(value);
    this.itemValueSubmit = false;
    this.itemValueForm.reset();
  }

  selecItemAdditionalDetailsList(i) {
    this.addItemAdditionalDetailsArr = this.itemAdditionalDetailsArr[i].item_additional_details_values;
    this.itemAddModel.variantName = this.itemAdditionalDetailsArr[i].variantName
    this.itemAdditionalDetailsArr.splice(i, 1);
  }

  itemAdditionaldetailsAdd() {
    let Item_AdditionalDetails_Arr = [];
    let item_AdditionalDetails_List;
    for (let i = 0; i < this.addItemAdditionalDetailsArr.length; ++i) {
      item_AdditionalDetails_List = { 'value': this.addItemAdditionalDetailsArr[i]['value'], 'unit_id': this.addItemAdditionalDetailsArr[i]['unit_id'] ? this.addItemAdditionalDetailsArr[i]['unit_id'] : '', 'unit_name': this.addItemAdditionalDetailsArr[i]['unit_name'] ? this.addItemAdditionalDetailsArr[i]['unit_name'] : '' }
      Item_AdditionalDetails_Arr.push(item_AdditionalDetails_List);
    }
    this.itemAdditionalDetailsArr.push({ 'variantName': this.itemAddModel.variantName, 'item_additional_details_values': Item_AdditionalDetails_Arr })
    this.addItemAdditionalDetailsArr = [];
  }


  updateCustomeFieldsOrder(customerCustomFieldArr) {
    const updateCustomeOrderSubs = this.itemsService.updateCustomeOrder(customerCustomFieldArr).subscribe((res) => {
      if (res.message == 'success' || res.status === 1) {
      }
    })
    this.subscriptions.push(updateCustomeOrderSubs);
  }

  private rememberItemFormulaJson(fieldId: string, formulaJson: any): void {
    if (!fieldId || !formulaJson) {
      return;
    }
    const field = (this.customerCustomFieldArr || []).find(
      (f) => String(f.id) === String(fieldId),
    );
    if (field) {
      field.item_formula_json = formulaJson;
    }
    const rows = Array.isArray(this.customDataFieldViewData)
      ? [...this.customDataFieldViewData]
      : [];
    const existing = rows.find(
      (d) => String(d.customerCustomFieldId || d.custom_field_id) === String(fieldId),
    );
    if (existing) {
      existing.formula_json = formulaJson;
    } else {
      rows.push({
        customerCustomFieldId: fieldId,
        field_type_id: formulaFieldTypeId(),
        value: '',
        apply_formula: true,
        formula_json: formulaJson,
      });
      if (field) {
        field.apply_formula = true;
      }
    }
    this.customDataFieldViewData = rows;
  }

  /** Build items_custom_field_datas payload, including per-item formula apply flags. */
  private coerceApplyFormula(value: unknown): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  /**
   * Custom-field update APIs return the request body, not the stored field.
   * Keep per-item apply_formula / option lists so the item form stays in sync.
   */
  private mergeUpdatedCustomField(previous: any, updated: any): any {
    if (!previous) {
      return updated;
    }
    const incomingValues = updated?.customer_custom_field_values;
    const incomingItemData = updated?.itemsCustomFieldData;
    return {
      ...previous,
      ...updated,
      id: updated?.id || previous.id,
      itemsCustomFieldData:
        Array.isArray(incomingItemData) && incomingItemData.length
          ? incomingItemData
          : previous.itemsCustomFieldData,
      apply_formula:
        updated?.apply_formula !== undefined && updated?.apply_formula !== null
          ? updated.apply_formula
          : previous.apply_formula,
      item_formula_json:
        updated?.item_formula_json !== undefined
          ? updated.item_formula_json
          : previous.item_formula_json,
      customer_custom_field_values:
        Array.isArray(incomingValues) && incomingValues.length
          ? incomingValues
          : previous.customer_custom_field_values,
    };
  }

  private resolveApplyFormula(formValues: Record<string, unknown>, field: any): boolean {
    const child = this.getActiveCustomFormFieldsComponent();
    if (child) {
      return this.coerceApplyFormula(child.getFormulaApply(field.id));
    }
    const controlKey = 'apply_formula_' + field.id;
    if (formValues && controlKey in formValues) {
      return this.coerceApplyFormula(formValues[controlKey]);
    }
    return this.coerceApplyFormula(field.apply_formula);
  }

  /**
   * The custom-fields form the user is editing. Same rule as develop's @ViewChild('custom'): the
   * FIRST #custom instance in the view. The template has two (old UI ~1050, new UI ~4420) behind
   * mutually exclusive @if (hideOldUi) blocks, so only one is ever rendered.
   */
  private getActiveCustomFormFieldsComponent(): CustomFormFieldsComponent | undefined {
    return this.customFormFieldsComponent ?? this.customFormFieldsComponents?.first;
  }

  private getCustomFieldFormValues(form?: any): Record<string, unknown> {
    if (form?.value) {
      return form.value;
    }
    return this.getActiveCustomFormFieldsComponent()?.getFormValues?.() || {};
  }

  private syncFormulaApplyFlagsToCustomFieldArr(): void {
    if (!this.customerCustomFieldArr?.length) {
      return;
    }
    const itemId = this.inputData?.id;
    const savedByFieldId = new Map(
      (this.customDataFieldViewData || []).map((d) => [
        String(d.customerCustomFieldId || d.custom_field_id),
        d,
      ]),
    );
    let changed = false;

    for (const field of this.customerCustomFieldArr) {
      if (!isFormulaType(field.field_type_id)) {
        continue;
      }

      // Rod, 2026-10-09: a NEW product starts with a copy of the newest recipe another product uses
      // for this field, switched on. It is this product's own copy (editing it changes nothing
      // elsewhere), and the field shows a notice to check or edit it (copiedFormulaFieldIds).
      if (
        itemId == null &&
        !savedByFieldId.has(String(field.id)) &&
        !this.formulaRecipesThisSession.has(String(field.id)) &&
        !this.copiedFormulaFieldIds.has(String(field.id)) // copied once per session, never again
      ) {
        const seed = this.newestSiblingRecipe(field);
        if (seed) {
          this.rememberItemFormulaJson(field.id, seed);
          this.copiedFormulaFieldIds.add(String(field.id));
          field.formula_copied = true;
          savedByFieldId.set(String(field.id), { customerCustomFieldId: field.id, apply_formula: true, formula_json: seed });
          changed = true;
        }
      }

      const saved = savedByFieldId.get(String(field.id));
      let next: boolean | null = null;

      if (saved != null && saved.apply_formula !== undefined && saved.apply_formula !== null) {
        next = this.coerceApplyFormula(saved.apply_formula);
      } else if (itemId != null) {
        const fromFieldList = (field.itemsCustomFieldData || []).find(
          (d) => String(d.itemId) === String(itemId),
        );
        if (fromFieldList != null) {
          next = this.coerceApplyFormula(fromFieldList.apply_formula);
        }
      } else if (saved != null) {
        next = this.coerceApplyFormula(saved.apply_formula);
      }

      const itemFormula =
        saved?.formula_json ||
        (itemId != null
          ? (field.itemsCustomFieldData || []).find((d) => String(d.itemId) === String(itemId))
              ?.formula_json
          : null);
      if (itemFormula && field.item_formula_json !== itemFormula) {
        field.item_formula_json = itemFormula;
        changed = true;
      }

      if (next == null) {
        next = !!itemFormula;
      }

      if (field.apply_formula !== next) {
        field.apply_formula = next;
        changed = true;
      }
    }

    const bothSourcesReady =
      this.customFieldLoadState.itemValues && this.customFieldLoadState.definitions;
    if (changed || (bothSourcesReady && !this.customFieldFlagsSynced)) {
      this.customerCustomFieldArr = [...this.customerCustomFieldArr];
      if (bothSourcesReady) {
        this.customFieldFlagsSynced = true;
      }
    }
  }

  /** The user edited this field's formula for this product: the "copied" notice is answered. */
  private clearCopiedFormulaNotice(fieldId: string | number): void {
    this.copiedFormulaFieldIds.delete(String(fieldId));
    const field = (this.customerCustomFieldArr || []).find((f) => String(f?.id) === String(fieldId));
    if (field?.formula_copied) {
      field.formula_copied = false;
      this.customerCustomFieldArr = [...this.customerCustomFieldArr];
    }
  }

  /**
   * Rod, 2026-10-11 (option A): switching "Calculate on quotes" ON for a product that has no recipe
   * for the field (a CSV-imported product, or one created before the field existed) copies the
   * newest switched-on recipe, exactly like a new product does. Before this the switch saved as
   * on with nothing behind it, and the server stored it as off without a word.
   */
  onFormulaApplyChange(event: { fieldId: string; on: boolean }): void {
    if (!event?.on) {
      return;
    }
    const id = String(event.fieldId);
    const field = (this.customerCustomFieldArr || []).find((f) => String(f?.id) === id);
    if (!field || !isFormulaType(field.field_type_id)) {
      return;
    }
    const viewRow = (this.customDataFieldViewData || []).find(
      (d) => String(d?.customerCustomFieldId || d?.custom_field_id) === id,
    );
    const ownRecipe = this.formulaRecipesThisSession.get(id) || field.item_formula_json || viewRow?.formula_json;
    if (ownRecipe || this.copiedFormulaFieldIds.has(id)) {
      return;
    }
    // Card #701: with no other product to copy from, use the field's own formula (set in Settings).
    // Without either the switch saves with nothing behind it and the server stores it as off.
    const sibling = this.newestSiblingRecipe(field);
    const seed = sibling || fieldOwnFormula(field);
    if (!seed) {
      return;
    }
    this.rememberItemFormulaJson(id, seed);
    this.copiedFormulaFieldIds.add(id);
    field.formula_copied = true;
    field.formula_copied_from = sibling ? 'item' : 'field';
    this.customerCustomFieldArr = [...this.customerCustomFieldArr];
  }

  /** Formula fields whose recipe on this NEW product was copied from another product. */
  private copiedFormulaFieldIds = new Set<string>();

  /**
   * The newest recipe another product has SWITCHED ON for this field, parsed; null when none does.
   * A recipe every product switched off is never revived on a new product. Newest = updated_at,
   * then created_at.
   */
  private newestSiblingRecipe(field: any): any {
    const parse = (v: any) => {
      if (!v) return null;
      if (typeof v === 'object') return v;
      try {
        return JSON.parse(v);
      } catch {
        return null;
      }
    };
    const rows = (field?.itemsCustomFieldData || [])
      .filter((d: any) => this.coerceApplyFormula(d?.apply_formula))
      .map((d: any) => ({ d, formula: parse(d?.formula_json) }))
      .filter((r: any) => r.formula && typeof r.formula === 'object');
    if (!rows.length) {
      return null;
    }
    const time = (d: any) => new Date(d?.updated_at || d?.created_at || 0).getTime() || 0;
    rows.sort((a: any, b: any) => time(b.d) - time(a.d));
    return JSON.parse(JSON.stringify(rows[0].formula));
  }

  private markCustomFieldSourceLoaded(source: 'definitions' | 'itemValues'): void {
    this.customFieldLoadState[source] = true;
    if (this.customFieldLoadState.definitions && this.customFieldLoadState.itemValues) {
      this.syncFormulaApplyFlagsToCustomFieldArr();
      this.refreshCustomFormFieldsDisplay(true);
    }
  }

  private refreshCustomFormFieldsDisplay(reloadFromServer = false): void {
    if (reloadFromServer) {
      this.syncFormulaApplyFlagsToCustomFieldArr();
    }
    this.applyFormulaTogglesWhenViewReady();
  }

  ngAfterViewInit(): void {
    this.applyFormulaTogglesWhenViewReady();
  }

  private applyFormulaTogglesWhenViewReady(): void {
    if (this._destroyed) {
      return;
    }
    const child = this.getActiveCustomFormFieldsComponent();
    if (child) {
      this.clearCustomFieldsViewWait();
      child.refreshFormulaApplyToggles();
      return;
    }
    const notifier = this.ensureUnsubscribeSubject();
    const boundToCurrentNotifier = this.customFieldsViewNotifier === notifier && !notifier.closed;
    if (this.customFieldsViewSub && !this.customFieldsViewSub.closed && boundToCurrentNotifier) {
      return;
    }
    this.retireCustomFieldsViewSub();
    const changes = this.customFormFieldsComponents?.changes;
    if (!changes || notifier.closed) {
      this.waitingForCustomFieldsView = false;
      return;
    }
    const stop$ = this.customFieldsViewStop$;
    this.customFieldsViewNotifier = notifier;
    this.customFieldsViewSub = changes
      .pipe(
        take(1),
        takeUntil(stop$),
        takeUntil(notifier),
        finalize(() => {
          this.waitingForCustomFieldsView = false;
        }),
      )
      .subscribe(() => {
        if (this._destroyed) {
          return;
        }
        if (this.customFieldsViewNotifier !== notifier) {
          this.applyFormulaTogglesWhenViewReady();
          return;
        }
        this.getActiveCustomFormFieldsComponent()?.refreshFormulaApplyToggles();
      });
    if (this._destroyed || this.customFieldsViewSub.closed || this.customFieldsViewNotifier !== notifier) {
      this.customFieldsViewSub = null;
      this.customFieldsViewNotifier = null;
      this.waitingForCustomFieldsView = false;
      return;
    }
    this.waitingForCustomFieldsView = true;
  }

  private retireCustomFieldsViewSub(): void {
    const stop$ = this.customFieldsViewStop$;
    this.customFieldsViewSub?.unsubscribe();
    this.customFieldsViewSub = null;
    this.customFieldsViewNotifier = null;
    this.waitingForCustomFieldsView = false;
    if (stop$ && !stop$.closed) {
      stop$.next();
      stop$.complete();
    }
    if (!this._destroyed) {
      this.customFieldsViewStop$ = new Subject<void>();
    }
  }

  private clearCustomFieldsViewWait(): void {
    this.retireCustomFieldsViewSub();
  }

  private notifyCustomFieldDataReady(source: 'definitions' | 'itemValues'): void {
    this.markCustomFieldSourceLoaded(source);
  }

  private collectCustomFieldData(customForm?: any): any[] {
    const formValues = this.getCustomFieldFormValues(customForm);
    const customFieldData: any[] = [];
    const child = this.getActiveCustomFormFieldsComponent();

    (this.customerCustomFieldArr || []).forEach((data) => {
      const fieldTypeId = String(data.field_type_id);
      if (isFormulaType(fieldTypeId)) {
        const id = String(data.id);
        // The recipe configured in THIS session wins; the field-list copy can be lost when the list
        // is reloaded from the server (which returns no per-item recipe for a not-yet-created item).
        const viewRow = (this.customDataFieldViewData || []).find(
          (d) => String(d?.customerCustomFieldId || d?.custom_field_id) === id,
        );
        const recipe = this.formulaRecipesThisSession.get(id) || data.item_formula_json || viewRow?.formula_json;
        // A Formula field created in this session applies to this product unless the user switched
        // it off (test plan: "Create a Formula field on product A → Apply on quote is on for A").
        const createdNow = this.formulaFieldsCreatedThisSession.has(id);
        const userEdited = !!child?.hasUserEditedFormulaApply?.(data.id);
        const row: any = {
          value: '',
          customerCustomFieldId: data.id,
          field_type_id: data.field_type_id,
          apply_formula: createdNow && !userEdited ? true : this.resolveApplyFormula(formValues, data),
        };
        if (recipe) {
          // Same row shape for item CREATE and UPDATE: { customerCustomFieldId, field_type_id: '7',
          // value: '', apply_formula, formula_json }. The backend stores formula_json per item.
          row.formula_json = recipe;
        }
        customFieldData.push(row);
        return;
      }

      if (fieldTypeId === '2') {
        (data.customer_custom_field_values || []).forEach(element => {
          if (formValues['value_' + data.id + '_' + element.value] == true) {
            customFieldData.push({
              value: element.value,
              customerCustomFieldId: data.id,
              field_type_id: data.field_type_id,
            });
          }
        });
      } else if (fieldTypeId === '4') {
        (data.customer_custom_field_values || []).forEach(element => {
          if (element.value == formValues['value_' + data.id + '_radio']) {
            customFieldData.push({
              value: element.value,
              customerCustomFieldId: data.id,
              field_type_id: data.field_type_id,
            });
          }
        });
      } else if (fieldTypeId === '5') {
        (data.customer_custom_field_values || []).forEach(element => {
          if (element.value == formValues['value_' + data.id + '_dropdown']) {
            customFieldData.push({
              value: element.value,
              customerCustomFieldId: data.id,
              field_type_id: data.field_type_id,
            });
          }
        });
      } else if (fieldTypeId === '3') {
        customFieldData.push({
          value: formValues['value_' + data.id + '_date'],
          customerCustomFieldId: data.id,
          field_type_id: data.field_type_id,
        });
      } else if (fieldTypeId === '6') {
        customFieldData.push({
          value: formValues['value_' + data.id + '_color'],
          customerCustomFieldId: data.id,
          field_type_id: data.field_type_id,
        });
      } else {
        customFieldData.push({
          value: formValues['value_' + data.id],
          customerCustomFieldId: data.id,
          field_type_id: data.field_type_id,
        });
      }
    });

    return customFieldData;
  }

  updateItem(form?) {
    if (this.itemAddModel) {
      this.userBasicInfoSubmit = true;
      this.userBasicInfoSubmit = true;
      if (this.userBasicInfoForm.invalid) {
        return;
      }
      else {
        this.itemPriceAdd();
        // =====================  item_additional_details_values ===========================

        let itemAdditionalDetailsUpdateArr = [];
        let itemAdditionalDetailsUpdateList;

        for (let i = 0; i < this.itemAdditionalDetailsArr.length; ++i) {
          let itemAdditionalDetailsValues = this.itemAdditionalDetailsArr[i]['item_additional_details_values'];
          let itemAdditionalUpdateArr = [];
          for (let j = 0; j < itemAdditionalDetailsValues.length; ++j) {
            let item_additional_details_values_list = { 'value': itemAdditionalDetailsValues[j]['value'], 'unit_id': itemAdditionalDetailsValues[j]['unit_id'], 'unit_name': itemAdditionalDetailsValues[j]['unit_name'] }
            itemAdditionalUpdateArr.push(item_additional_details_values_list);
          }
          itemAdditionalDetailsUpdateList = { 'variantName': this.itemAdditionalDetailsArr[i]['variantName'], 'item_additional_details_values': itemAdditionalUpdateArr }
          itemAdditionalDetailsUpdateArr.push(itemAdditionalDetailsUpdateList);
        }

        this.itemAddModel.item_additional_details = itemAdditionalDetailsUpdateArr;
        // ===================== item_additional_details_values  ===========================

        // ===================== sub_items  ===========================
        let Item_Code_Arr = [];
        let subitemId_List;
        for (var i = 0; i < this.addEditItemCodeArr.length; ++i) {
          subitemId_List = { 'subitemId': this.addEditItemCodeArr[i]['id'] }
          Item_Code_Arr.push(subitemId_List);
        }
        this.itemAddModel.sub_items = Item_Code_Arr;
        // ===================== sub_items  ===========================

        // ===================== item_bundles  ===========================

        let Item_Bundles_Arr = [];
        let itemBundlesList;
        for (var i = 0; i < this.selectedBundle.length; ++i) {
          itemBundlesList = this.selectedBundle[i]['item_bundles']
          Item_Bundles_Arr.push(itemBundlesList);
        }
        this.itemAddModel.item_bundles = Item_Bundles_Arr;
        // ===================== item_bundles  ===========================

        // ===================== item_warehouses  ===========================
        this.itemAddModel.item_warehouses = this.addWarehouseArr;
        // ===================== item_warehouses  ===========================
        this.itemAddModel.item_images = this.editItemsImages;
        this.flushPendingComments();
        this.itemAddModel.comments = this.comments;
        this.itemAddModel.unit_quantity = this.numberField.get('numberValue').value
        this.itemAddModel.categoryId = this.categoryId
        this.itemAddModel.subCategoryId = this.subCategoryId
        this.itemAddModel.subcategory_id = this.subCategoryId
        this.itemAddModel.ItemsDeactivated = this.isCheckedItems
        this.itemAddModel.first_url_title = this.firstUrlTitle
        this.itemAddModel.second_url_title = this.secondUrlTitle
        this.itemAddModel.unit = this.unitSelect.value
        this.itemAddModel.track_inventory = this.inventory.value
        this.itemAddModel.item_coming_from = this.itemType.value

        // ===================== item_warehouses  ===========================

        // working here 
        const customForm = this.getActiveCustomFormFieldsComponent()?.customFielsDataFrom || form;
        this.customFieldDataArr = this.collectCustomFieldData(customForm);
        this.itemAddModel.items_custom_field_datas = this.customFieldDataArr;
        this.itemAddModel.isDeactivated = this.isChecked;
        const addItemSubss = this.itemsService.updateTexValues(this.itemAddModel?.item_prices_taxs).subscribe(res => {

        })
        if (this.itemAddModel?.item_images?.length) {
          const allImagesHaveCreatedAt = this.itemAddModel.item_images.every(img => img?.created_at);
          if (!allImagesHaveCreatedAt) {
            let earliestCreatedAt = this.itemAddModel.item_images
              .filter(img => img?.created_at)
              .map(img => new Date(img?.created_at).getTime())
              .reduce((min, current) => Math.min(min, current), Infinity);
            let baseTime = earliestCreatedAt !== Infinity ? earliestCreatedAt : new Date().getTime();
            this.itemAddModel.item_images = this.itemAddModel.item_images.map((img, index) => {
              if (!img.created_at) {
                return { ...img, created_at: new Date(baseTime - (index + 1) * 10).toISOString() };
              }
              return img;
            });
          }

        }





        const updateItemSubs = this.itemsService.updateItem(this.itemAddModel).subscribe(
          res => {
            if (res.message === 'success' || res.status === 1) {
              if (typeof this.mainImageUrl === 'object' && Object.keys(this.mainImageUrl).length > 0) {
                const uploadItemPhotoSubs = this.itemsService.uploadItemOrder(this.mainImageUrl).subscribe();
                // this.subscriptions.push(uploadItemPhotoSubs); 

              }
              res.data.id = this.inputData.id;
              if (this.comments?.length) {
                res.data.comments = this.comments;
              }
              this.dialogRef.close({ ...res?.data, comments: this.comments, tex: this.addItemPriceTaxArr, showTex: true });
              this.itemImage.length = 0;
            } else {
            }
          });
        this.subscriptions.push(updateItemSubs);
      }
    }
  }

  addSubCateogry(subcateogryForm) {
    if (subcateogryForm.form.valid) {
      const addSubCateogrySubs = this.itemsService.addSubCateogry(this.subCategoryAddModel).subscribe(
        res => {
          if (res.message === 'success' || res.status === 1) {
            this.getSubCategoryList();
          } else {
          }
        });
      this.subscriptions.push(addSubCateogrySubs);
    }
  }

  // WarehouseList ----------------------
  getWarehouseList(): Promise<any> {
    return new Promise((resolve, reject) => {
      const warehouseList = this.itemsService.warehouseList({ hideLoader: true }).subscribe(res => {
        if (res.message === 'success' || res.status === 1) {
          this.warehouseListArr = res.data;
          resolve(true)
        } else {
          reject(false)
        }
      });
      this.subscriptions.push(warehouseList);
    })

  }
  // WarehouseList ----------------------

  // addNewTex ---------------------
  getTaxList() {
    const getTaxesListSubs = this.itemsService.getTaxesList({ module_name: 'items', dropdown_name: 'taxes', hideLoader: true }).subscribe(res => {
    
      if (res.data?.length) {
        const getTaxCustomValuesSubs = this.itemsService.itemTexCustomValuess({ hideLoader: true }).subscribe(ress => {

          if (ress?.results?.length) {
            res.data.forEach((item: any) => {
              // Find corresponding element in results array based on customValueId
              const resultItem = ress?.results.find((result: any) => result.customValueId === item.id);

              // If corresponding element is found, update taxe_value
              if (resultItem) {
                item.taxe_values = resultItem.taxe_value;
              }
            });
          }

        });
        this.subscriptions.push(getTaxCustomValuesSubs); // Push the subscription to subscriptions array
      }

      this.taxListArr = res.data;
    });

    this.subscriptions.push(getTaxesListSubs); // Push the subscription to subscriptions array
  }

  addNewTex() {
    const addNewTexSubs = this.itemsService.addNewTex(this.addNewTexListForm.value).subscribe(
      res => {
        // Optimistically push the new tax into the list so it appears immediately,
        // then refresh from the server to stay in sync.
        const newTax = res?.data ?? res;
        if (newTax?.id) {
          this.taxListArr = [...this.taxListArr, newTax];

          const selectedValue = {
            customValueId: newTax.id,
            name: newTax.name,
            complete: newTax,
          };

          // Auto-select the newly created tax in the Applicable Taxes dropdown.
          this.itemPriceTaxForm.get('taxData')?.setValue(selectedValue);

          // Auto-patch the new tax into the item's tax list.
          this.onOptionSelected({ value: selectedValue });
        }

        // Refresh the full list from the server.
        this.getTaxList();

        // Reset the inline creation form so it's blank for the next use.
        this.addNewTexListForm.reset();
      });
    this.subscriptions.push(addNewTexSubs);
  }
  // addNewTex ----------------------

  // addNewBundle ----------------------
  addNewBundle() {
    this.itemAddBundleSubmit = true;
    if (this.addNewItemBundle.invalid) {
      return;
    }
    this.closeAddBundle.nativeElement.click();
    const addNewBundleSubs = this.itemsService.addNewBundle(this.addNewItemBundle.value).subscribe(
      res => {
        if (res.message === 'success' || res.status === 1) {
          this.getBundleIdList();
          this.addNewItemBundle.reset();
          this.itemAddBundleSubmit = false;
        }
      });
    this.subscriptions.push(addNewBundleSubs);
  }
  // addNewBundle ----------------------


  // addNewUnit Start ---------------------

  getUnitList() {
    const getTaxesListSubs = this.itemsService.getTaxesList({ module_name: 'items', dropdown_name: 'unit', hideLoader: true }).subscribe(res => {

      this.unitListArr = res.data;

    });
    this.subscriptions.push(getTaxesListSubs);
  }

  addNewUnit() {
    this.itemUnitSubmit = true;
    if (this.addNewUnitForm.invalid) {
      return;
    }
    this.closeAddUnithouse.nativeElement.click();
    const addNewUnitSubs = this.itemsService.addNewUnit(this.addNewUnitForm.value).subscribe(
      res => {
        this.getUnitList();
      });
    this.subscriptions.push(addNewUnitSubs);
  }

  // addNewUnit End----------------------

  changeValueHide(event, index) {
    this.hidePrice = event.currentTarget.checked;
    this.selectedBundle[index]['item_bundles']['hide_price'] = this.hidePrice ? "1" : "0";
  }

  // trackInventory(event) {
  //   this.trackInv = event.currentTarget.checked;
  //   this.itemAddModel.track_inventory = this.trackInv ? "1" : "0";
  // }

  outOfStock(event) {
    this.outOfStoc = event.currentTarget.checked;
    this.itemAddModel.out_of_stock = this.outOfStoc ? "1" : "0";
  }

  advUnitCal(event) {
    this.advanceUnitCal = event.currentTarget.checked;
    this.itemAddModel.advance_unit_cal = this.advanceUnitCal ? "1" : "0";
  }

  addminPrice(event: any) {
    const numericRegex = /^(\d*\.?\d*)$/;
    const numericValue = parseFloat(event.target.value.replace(/[$,]/g, ''));
    if (isNaN(numericValue)) {
      if (!numericRegex.test(event.target.value)) {
        // If the input value does not match the numeric regex, clear the value in the form control
        this.itemPriceForm.get('pricesC').setValue('');
      }
      this.userBasicInfoForm.get('min_price').setValue('');

    }
    if (!isNaN(numericValue)) {
      let formattedCurrency = this.currencyPipe.transform(numericValue, 'USD', '', '1.2-2');
      this.userBasicInfoForm.get('min_price').setValue(formattedCurrency);
      this.minPrice = formattedCurrency;
    }
  }

  async imageFilesAddedEdit(event: any) {
    const formData = new FormData();
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const allowedFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const files = event?.target?.files;

    if (!files || files.length === 0) {
      return;
    }

    if (files.length > 1) {
      this.snackbar.open(
        this.translateService.instant('COMMON.You can only upload one image at a time.'),
        this.translateService.instant('COMMON.OK'),
        { duration: 5000 }
      );
      if (event.target) event.target.value = '';
      return;
    }

    for (let i = 0; i < files.length; ++i) {
      const file = files[i];

      if (file.size > maxFileSize) {
        this.snackbar.open(
          this.translateService.instant('Snackbar.File size exceeds the limit of 5MB. Please select a smaller file.'),
          this.translateService.instant('COMMON.OK'),
          { duration: 5000 }
        );
        if (event.target) event.target.value = '';
        return;
      }

      if (!allowedFileTypes.includes(file.type?.toLowerCase())) {
        this.snackbar.open(
          `Invalid file type: ${file.name}. Only JPEG/PNG are allowed.`,
          this.translateService.instant('COMMON.OK'),
          { duration: 5000 }
        );
        if (event.target) event.target.value = '';
        return;
      }

      try {
        const compressedBlob = await this.compressImage(file, 0.6);
        const compressedFile = new File([compressedBlob], file.name, {
          type: compressedBlob.type,
        });
        formData.append('files', compressedFile);
      } catch (err) {
        console.error(`Compression failed for ${file.name}:`, err);
        formData.append('files', file);
      }
    }

    if (formData.has('files')) {
      const uploadItemPhotoSubs = this.itemsService.uploadItemImages(formData).subscribe(
        res => {
          if (res.message === 'success' || res.status === 1) {
            this.editItemsImages.push({ 'image': res.data.image });
            this.image = { 'image': res.data.image };
          }
        },
        error => {
          console.error('Error uploading images:', error);
          this.snackbar.open('Error uploading image. Please try again.', 'OK', { duration: 5000 });
        }
      );
      this.subscriptions.push(uploadItemPhotoSubs);
    }
    if (event.target) event.target.value = '';
  }


  compressImage(file: File, quality = 0.6): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      const img = new Image();

      reader.onload = (event: any) => {
        img.src = event.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        let width = img.width;
        let height = img.height;
        const maxDimension = 1920;

        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = Math.round((height * maxDimension) / width);
            width = maxDimension;
          } else {
            width = Math.round((width * maxDimension) / height);
            height = maxDimension;
          }
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error("Compression failed"));
          },
          'image/jpeg',
          quality
        );
      };

      img.onerror = reject;
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }



  async userCustomUrl() {
    let merchantId = localStorage.getItem('merchant_id');
    const userCustom = this.itemsService.userCustomUrl({ merchantId: merchantId, hideLoader: true }).subscribe(res => {
      this.firstUrlTitle = res[0]?.first_url_title
      this.secondUrlTitle = res[0]?.second_url_title
    });
    this.subscriptions.push(userCustom);
  }



  salesCommType(val) {
    this.userBasicInfoForm?.controls?.sales_commission.setValue('');
    this.sales_commission_type = String(val);
    this.itemAddModel.sales_comm_type = val;
    this.calculateProfit();
  }

  // Item Add Edit ----------------------
  async editItemList() {
    const editItemListSubs = this.itemsService.iteamDataList(this.inputData.id).subscribe(async res => {
      this.customDataFieldViewData = [...(res?.data?.items_custom_field_datas || [])];
      this.notifyCustomFieldDataReady('itemValues');
      $('.subitem_menu').css('display', 'block');
      $('.bundles_menu').css('display', 'block');
      this.isChecked = this.inputData?.isDeactivated
      this.itemAddModel = res.data;
      this.isDeactivated = true
      this.editItemsImages = this.itemAddModel.item_images.sort((a, b) => {
        // Check if any images have a defined images_order
        const hasImagesOrder = this.itemAddModel.item_images.some(image => image.images_order !== 0);

        // Log the result of the check

        if (!hasImagesOrder) {
          // Sort by created_at (oldest date first) if no images_order is present
          const dateDifference = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();

          if (dateDifference !== 0) {
            return dateDifference;
          }

          // Fallback to a unique identifier (like id) if created_at is identical
          return (a.id || 0) - (b.id || 0);
        }

        // Existing sorting logic based on images_order
        if (a.images_order === null && b.images_order === null) {
          return 0; // No change in order
        }
        if (a.images_order === null) {
          return 1; // Put images with null order after others
        }
        if (b.images_order === null) {
          return -1; // Put images with null order before others
        }
        if (a.images_order === 1) {
          return -1; // Put images with images_order 1 at the top
        }
        if (b.images_order === 1) {
          return 1; // Put images with images_order 1 at the top
        }

        // Sort by images_order
        return (a.images_order || 0) - (b.images_order || 0);
      });


      const userImageData = this.editItemsImages[0]
      this.onEditSHowMainImage(userImageData)
      // this.userBasicInfoForm.get('deactivate_item').valueChanges.subscribe((value)=>{
      //   if(value){
      //     const dialogData = new ModalModel(
      //       this.translateService.instant('ITEMS.DEACTIVATED')
      //     );
      //     const dialogRef = this.dialog.open(ModalComponent, {
      //       width: '450px',
      //       data: dialogData,
      //     });
      //     dialogRef.afterClosed().subscribe(async (dialogResult) => {
      //       if (dialogResult) {
      //         this.isCheckedItems=dialogResult

      //       }
      //     });
      //   }
      // })
      let selectedCat = this.cateogryListArr?.find(item => item.id == this.inputData.categoryId);
      if (this.inputData.categoryId) {
        await this.getCatId(this.inputData.categoryId)
      }
      let selectedSubCat = this.subCategoryListArr?.find(item => { return item.id == this.itemAddModel.subcategory_id });
      this.unitSelect.patchValue(this.itemAddModel?.unit)
      this.inventory.patchValue(this.itemAddModel?.track_inventory)
      this.itemType.patchValue(this.itemAddModel?.item_coming_from)
      this.userBasicInfoForm.patchValue({
        categoryId: selectedCat?.name,
        subCategoryId: selectedSubCat?.name

      })


      this.addEditItemCodeArr = this.itemAddModel.childitems;
      if (selectedSubCat?.name) {
        this._autoCompleteSearchControlForSubCategory()

      }

      const bundles = this.itemAddModel.bundles;
      let bundlesListData;
      for (let i = 0; i < bundles?.length; ++i) {
        bundlesListData = { 'item_bundles': { 'bundleId': bundles[i]['id'], 'title': bundles[i]['title'], 'hide_price': bundles[i]['item_bundles']['hide_price'] } }
        this.selectedBundle.push(bundlesListData);
      }
      this.itemAdditionalDetailsArr = this.itemAddModel.item_additional_details
      const warehouses = this.itemAddModel.warehouses;
      let warehousesListData;
      for (let i = 0; i < warehouses?.length; ++i) {
        this.addWarehouseArr.push({ status: 1, 'warehouseId': warehouses[i]['id'], 'name': warehouses[i]['name'], 'items': warehouses[i]['item_warehouses']['items'] });
      }
      // ===================== Item_price_discounts  ===========================
      let discountValue = ''
      if (this.itemAddModel?.item_prices[0] !== undefined) {
        if (this.itemAddModel?.item_prices[0]['discount'] !== null) {
          discountValue = this.itemAddModel?.item_prices[0]['discount'].split(',');
        }
      }


      let discountValueList;
      let discountValueArr = [];
      for (let i = 0; i < discountValue.length; ++i) {
        discountValueList = { 'discounts': discountValue[i] }
        discountValueArr.push(discountValueList);
      }
      this.addDiscountsArr = discountValueArr;
      this.addDiscountsArr.sort((a, b) => a.discounts - b.discounts); // b - a for reverse sort
      // ===================== Item_price_discounts  ===========================

      // ===================== Item_price_price  ===========================  
      // this.addPriceArr = JSON.parse(this.itemAddModel?.item_prices[0]['price']);
      // this.itemPriceForm.patchValue(JSON.parse(this.itemAddModel?.item_prices[0]['price']))
      if (this.itemAddModel?.item_prices[0] !== undefined) {
        const itemPrices = JSON.parse(this.itemAddModel?.item_prices[0]['price']);
        const sanitizedPrices = Object.keys(itemPrices).reduce((result, key) => {
          let formattedPrice = itemPrices[key];

          // Replace "NaN" with an empty string
          if (formattedPrice === "NaN") {
            formattedPrice = '';
          } else {
            // Remove commas if it's not NaN and is a valid string
            formattedPrice = formattedPrice.replace(',', '');
          }

          result[key] = formattedPrice;
          return result;
        }, {});

        this.itemPriceForm.patchValue(sanitizedPrices);
      }




      this.numberField.get('numberValue').setValue(Number(this.itemAddModel.unit_quantity == null ? '1' : this.itemAddModel.unit_quantity))
      // ===================== Item_price_price  ===========================
      // ===================== Item_price  ===========================
      this.itemAddModel.price = this.itemAddModel?.item_prices[0] ? JSON.parse(this.itemAddModel?.item_prices[0]['price']) : '';
      let dbComments: any[] = [];
      if (typeof this.itemAddModel?.comments === 'string') {
        try {
          dbComments = JSON.parse(this.itemAddModel.comments);
        } catch {
          dbComments = this.itemAddModel.comments
            ? [{ title: this.itemAddModel.comments, status: 2 }]
            : [];
        }
      } else if (Array.isArray(this.itemAddModel?.comments)) {
        dbComments = this.itemAddModel.comments.map((c: any) => ({
          title: typeof c === 'string' ? c : (c?.title || c?.item_comments || c?.name || ''),
          status: 2,
          ...(typeof c === 'object' ? c : {})
        })).filter((c: any) => c.title);
      }

      // Merge initial/existing comments (e.g. added in quote table) with dbComments so no comments are lost
      const existingComments = Array.isArray(this.comments) ? this.comments : [];
      const mergedCommentsMap = new Map<string, any>();
      
      existingComments.forEach((c: any) => {
        const title = typeof c === 'string' ? c : (c?.title || c?.item_comments || c?.name || '');
        if (title && !mergedCommentsMap.has(title)) {
          mergedCommentsMap.set(title, typeof c === 'object' ? c : { title, status: 2 });
        }
      });
      
      dbComments.forEach((c: any) => {
        const title = typeof c === 'string' ? c : (c?.title || c?.item_comments || c?.name || '');
        if (title && !mergedCommentsMap.has(title)) {
          mergedCommentsMap.set(title, typeof c === 'object' ? c : { title, status: 2 });
        }
      });

      this.comments = Array.from(mergedCommentsMap.values());
      this.itemAddModel.min_price = this.itemAddModel?.item_prices[0]['min_price'] ?? 0;
      this.itemAddModel.currency_id = this.itemAddModel?.item_prices[0]['currency_id'];
      this.userBasicInfoForm.get('currency_id')?.patchValue(Number(this.itemAddModel?.item_prices[0]['currency_id']))
      this.itemAddModel.advance_unit_cal = this.itemAddModel?.item_prices[0]['advance_unit_cal'];
      this.itemAddModel.sales_commission = this.itemAddModel?.item_prices[0]['sales_commission'];
      this.itemAddModel.sales_comm_type = this.itemAddModel?.item_prices[0]['sales_comm_type'];
      this.itemAddModel.fix_cost_per_unit = this.itemAddModel?.item_prices[0]['fix_cost_per_unit'];
      this.itemAddModel.categoryId = this.inputData.categoryId

      // Patch pricing fields into form controls so calculateProfit() reads the
      // correct saved values instead of the stale defaults set in ngOnInit.
      this.userBasicInfoForm.get('sales_commission')
        ?.setValue(this.itemAddModel.sales_commission ?? '');
      this.userBasicInfoForm.get('fix_cost_per_unit')
        ?.setValue(this.itemAddModel.fix_cost_per_unit ?? 0);

      // Restore the saved commission type ('1' = fixed $, '2' = %) so the
      // calculation branch matches what was used when the item was created.
      // Without this, ngOnInit's default salesCommType('2') is used, which
      // treats a fixed-$ commission as a percentage and produces a wrong margin.
      if (this.itemAddModel.sales_comm_type != null) {
        this.sales_commission_type = String(this.itemAddModel.sales_comm_type);
      }

      // ===================== Item_price  ===========================

      const item_prices_tax = this.itemAddModel?.item_prices_taxs;
      let itemPricesTaxListData;

      if (item_prices_tax) {
        for (let i = 0; i < item_prices_tax.length; ++i) {
          if (
            item_prices_tax[i] &&
            item_prices_tax[i]['taxe_value'] &&
            item_prices_tax[i]['custom_value'] &&
            item_prices_tax[i]['custom_value']['name'] &&
            item_prices_tax[i]['customValueId']
          ) {
            itemPricesTaxListData = {
              'taxe_value': item_prices_tax[i]['taxe_value'],
              'taxData': {
                'name': item_prices_tax[i]['custom_value']['name'],
                'customValueId': item_prices_tax[i]['customValueId']
              }
            };
            this.addItemPriceTaxArr.push(itemPricesTaxListData);
          }
        }
      }

      this.addItemPriceTaxArr.sort((a, b) => a.taxe_value - b.taxe_value); // b - a for reverse sort

      // Recalculate profit margin using the fully-patched form values so the
      // Profit Margin widget shows the same value before and after save.
      this.calculateProfit();

    });
    this.subscriptions.push(editItemListSubs);
  }

  itemPriceAdd() {
    let Item_Discount_Arr = [];
    var discount_List;
    for (var i = 0; i < this.addDiscountsArr.length; ++i) {
      discount_List = this.addDiscountsArr[i]['discounts']
      Item_Discount_Arr.push(discount_List);
    }


    this.itemAddModel.item_prices = [{
      "price": JSON.stringify(this.itemPriceForm.value),
      "min_price": this.itemAddModel.min_price,
      "currency_id": this.userBasicInfoForm.get('currency_id').value,
      "discount": Item_Discount_Arr,
      "advance_unit_cal": this.itemAddModel.advance_unit_cal,
      "sales_commission": this.itemAddModel.sales_commission || 0,
      "sales_comm_type": this.itemAddModel.sales_comm_type,
      "fix_cost_per_unit": this.itemAddModel.fix_cost_per_unit,
    }]

    // ===================== items_price_tax  ===========================
    let itemPriceList = [];
    for (let i = 0; i < this.addItemPriceTaxArr.length; ++i) {
      let customValueId = this.addItemPriceTaxArr[i]['taxData'] ? this.addItemPriceTaxArr[i]['taxData']['customValueId'] : this.addItemPriceTaxArr[i]['id'];
      let items_price_tax = { 'taxe_value': this.addItemPriceTaxArr[i]['taxe_value'], 'customValueId': customValueId, merchant_id: localStorage.getItem('merchant_id') };
      itemPriceList.push(items_price_tax);
    }
    this.itemAddModel.item_prices_taxs = itemPriceList;
    // ===================== items_price_tax  ===========================

  }
  subCatId(id) {
    this.subCategoryId = id
  }


  addItem(form?) {
    // this.userBasicInfoSubmit = true

    if (this.itemPriceForm.invalid && this.currentTabIndex == 2) {
      this.itemPriceSubmit = true
      this.userBasicInfoSubmit = true
      return
    }
    if (this.currentTabIndex == 0) {
      if (!this.userBasicInfoForm.get('name').value) return
      this.currentTabIndex = 1
      this.refreshCustomFormFieldsDisplay(false);

    }
    else if (this.currentTabIndex == 1) {
      this.currentTabIndex = 2
    } else {
      if (this.itemAddModel) {
        this.userBasicInfoSubmit = true

        // Defensive trim: remove any leading/trailing whitespace from the name
        // that was not caught by the blur handler (e.g. programmatic setValue,
        // paste-then-click-Save without tabbing out of the field).
        const rawName: string = this.userBasicInfoForm.get('name')?.value || '';
        const trimmedName = rawName.trim();
        if (trimmedName !== rawName) {
          this.userBasicInfoForm.get('name').setValue(trimmedName);
          this.itemAddModel.name = trimmedName;
        }

        if (this.userBasicInfoForm.invalid) {
          return;
        }
        // else {
        this.itemPriceAdd();
        // ===================== item_additional_details  ===========================

        this.itemAddModel.item_additional_details = this.itemAdditionalDetailsArr;

        // ===================== item_additional_details  ===========================

        // ===================== sub_items  ===========================

        let Item_Code_Arr = [];
        let subitemId_List;
        for (let i = 0; i < this.addEditItemCodeArr?.length; ++i) {
          subitemId_List = { 'subitemId': this.addEditItemCodeArr[i]['id'] }
          Item_Code_Arr.push(subitemId_List);
        }
        this.itemAddModel.sub_items = Item_Code_Arr;
        // ===================== sub_items  ===========================

        // ===================== item_bundles  ===========================
        let Item_Bundles_Arr = [];
        let itemBundlesList;
        for (let i = 0; i < this.selectedBundle.length; ++i) {
          itemBundlesList = this.selectedBundle[i]['item_bundles']
          Item_Bundles_Arr.push(itemBundlesList);
        }
        this.itemAddModel.item_bundles = Item_Bundles_Arr;

        // ===================== item_bundles  ===========================

        // ===================== item_warehouses  ===========================


        this.itemAddModel.item_warehouses = this.addWarehouseArr;
        // ===================== item_warehouses  ===========================

        this.itemAddModel.item_images = this.editItemsImages;
        this.flushPendingComments();
        this.itemAddModel.comments = this.comments;
        this.itemAddModel.categoryId = this.categoryId
        this.itemAddModel.subCategoryId = this.subCategoryId
        this.itemAddModel.unit = this.unitSelect.value
        this.itemAddModel.track_inventory = this.inventory.value
        this.itemAddModel.item_coming_from = this.itemType.value

        this.itemAddModel.item_service_type = this.itemType.value
        this.itemAddModel.unit_quantity = this.numberField.get('numberValue').value
        this.itemAddModel.first_url_title = this.firstUrlTitle
        this.itemAddModel.second_url_title = this.secondUrlTitle


        // Adding Custom Fields;
        const customForm = this.getActiveCustomFormFieldsComponent()?.customFielsDataFrom || form;
        this.customFieldDataArr = this.collectCustomFieldData(customForm);
        this.itemAddModel.items_custom_field_datas = this.customFieldDataArr;
        const addItemSubss = this.itemsService.updateTexValues(this.itemAddModel?.item_prices_taxs).subscribe(res => {

        })

        const addItemSubs = this.itemsService.addItem(this.itemAddModel).subscribe(
          res => {
            if (res.message === 'success' || res.status === 1) {
              const returnData = res?.data || res;
              if (this.comments?.length) {
                returnData.comments = this.comments;
              }
              this.dialogRef.close({ ...res, data: returnData, comments: this.comments, tex: this.addItemPriceTaxArr, showTex: true });
              this.itemImage.length = 0;
            } else {
            }
          });
        this.subscriptions.push(addItemSubs);

      }
    }

  }



  // Item Add Edit ----------------------

  infoItem(id) {
    $('.hidden-info').css('display', 'none');
    $('.info-item').css('display', 'block');
    const iteamDataListSubs = this.itemsService.iteamDataList(id).subscribe(res => {
      this.itemViewModel = res.data;
      this.itemsImages = this.itemViewModel.item_images;
      this.mainImage = this.imageUrl + this.itemsImages[0].image;
    });
    this.subscriptions.push(iteamDataListSubs);
  }

  getImage(image) {
    return this.imageUrl + image;
  }

  changeMainImage(image) {
    this.mainImage = this.imageUrl + image;
  }

  async removeItem(i, type) {
    const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
    const dialogRef = this.dialog.open(ModalComponent, {
      maxWidth: "400px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {

        if (type == 'subitem') {
          this.addEditItemCodeArr.splice(i, 1);
        }

        if (type == 'imgRemove') {
          const imageIndex = this.editItemsImages.indexOf(i)

          this.editItemsImages.splice(imageIndex, 1);
          this.image = this.editItemsImages[0]
        }

        if (type == 'bundleRemove') {
          this.selectedBundle.splice(i, 1);
        }

        if (type == 'discountRemove') {
          this.addDiscountsArr.splice(i, 1);
        }

        if (type == 'priceRemove') {
          this.addPriceArr.splice(i, 1);
        }

        if (type == 'itemPriceRemove') {
          this.addItemPriceTaxArr.splice(i, 1);
        }

        if (type == 'removeDetails') {
          this.addItemAdditionalDetailsArr.splice(i, 1);
        }

        if (type == 'additionalDetailsArrList') {
          this.itemAdditionalDetailsArr.splice(i, 1);
        }

        if (type == 'warehouseRemove') {
          this.addWarehouseArr.splice(i, 1);
        }


      }
    });
  }
  selectedTabIndex(event) {
    this.currentTabIndex = event
    if (event === 1) {
      this.refreshCustomFormFieldsDisplay(false);
    }
  }

  /**
   * Navigate to previous tab
   */
  goToPreviousTab(): void {
    if (this.currentTabIndex > 0) {
      this.currentTabIndex = this.currentTabIndex - 1;
    }
  }

  /**
   * Navigate to next tab (for edit mode)
   */
  goToNextTab(): void {
    if (this.currentTabIndex < 2) {
      this.currentTabIndex = this.currentTabIndex + 1;
      if (this.currentTabIndex === 1) {
        this.refreshCustomFormFieldsDisplay(false);
      }
    }
  }

  /**
   * Navigate to a specific tab by index
   */
  goToTab(tabIndex: number): void {
    // Check if tab should be disabled (same logic as mat-tab)
    if (tabIndex === 1 || tabIndex === 2) {
      const nameValue = this.userBasicInfoForm?.get('name')?.value;
      const categoryIdValue = this.userBasicInfoForm?.get('categoryId')?.value;
      if (!nameValue || !categoryIdValue) {
        return; // Don't navigate if required fields are not filled
      }
    }
    this.currentTabIndex = tabIndex;
    if (tabIndex === 1) {
      this.refreshCustomFormFieldsDisplay(false);
    }
  }



  itemBasicInfoFormVal() {
    this.userBasicInfoForm = this.formBuilder.group(
      {
        subCategoryId: [''],
        categoryId: ['', Validators.required],
        video_url: ['', [AddEditItemComponent.httpsUrlValidator]],
        website_url: ['', [AddEditItemComponent.httpsUrlValidator]],
        description: [''],
        description_es: [''],
        description_fr: [''],
        item_coming_form: [''],
        currency_id: [''],
        sales_commission: [''],
        name: ['', Validators.required],
        code: [''],
        min_price: [0, Validators.required],
        variantName: [''],
        fix_cost_per_unit: [0, Validators.required],
        deactivate_item: [Boolean]
      }
    );

    this.editItemCodeForm = this.formBuilder.group(
      {
        item_code: ['']
      }
    );

    this.editItemBundleForm = this.formBuilder.group(
      {
        item_bundles: ['', Validators.required]
      }
    )

    this.itemPriceForm = this.formBuilder.group(
      {
        pricesA: ['', [Validators.required]],
        pricesB: ['', [Validators.min(1)]],
        pricesC: ['', [Validators.min(1)]],
        pricesD: ['', [Validators.min(1)]]
      }
    );
    this.itemDiscountForm = this.formBuilder.group({
      discounts: ['', [Validators.required, Validators.min(0), Validators.max(100)]]
    });

    this.itemPriceTaxForm = this.formBuilder.group(
      {
        taxData: ['', Validators.required],
        taxe_value: ['', Validators.required]
      }
    );

    this.itemValueForm = this.formBuilder.group(
      {
        value: [''],
        unit_id: ['']
      }
    );

    this.addNewUnitForm = this.formBuilder.group(
      {
        name: ['', Validators.required]
      }
    );

    this.newWarehouseForm = this.formBuilder.group(
      {
        name: ['', Validators.required]
      }
    );

    this.addNewTexListForm = this.formBuilder.group(
      {
        name: ['']
      }
    );

    this.addNewItemBundle = this.formBuilder.group(
      {
        title: ['', Validators.required]
      }
    );

    this.itemwarehouseListForm = this.formBuilder.group(
      {
        item_warehouses: ['', Validators.required],
        items: [1]
      }
    );
    this.userBasicInfoForm.get('fix_cost_per_unit')?.valueChanges.subscribe(() => {
      this.calculateProfit();
    });
    this.userBasicInfoForm.get('sales_commission')?.valueChanges.subscribe(() => {
      this.calculateProfit();
    });

    ['pricesA', 'pricesB', 'pricesC', 'pricesD'].forEach((key) => {
      this.itemPriceForm.get(key)?.valueChanges.subscribe(() => {
        this.validatePricesAgainstMinPrice();
      });
    });

    this.userBasicInfoForm.get('min_price')?.valueChanges.subscribe(() => {
      this.validatePricesAgainstMinPrice();
    });
  }

  /**
   * Called on blur of a URL field. If the user typed a bare hostname (e.g. "example.com")
   * without a scheme, prepend "https://" so the validator passes and the stored value
   * is a proper absolute URL.
   *
   * Also strips leading/trailing whitespace and blocks dangerous schemes — the validator
   * is the authoritative check, but this gives the user immediate normalisation feedback.
   */
  normalizeUrl(fieldName: 'video_url' | 'website_url'): void {
    const control = this.userBasicInfoForm.get(fieldName);
    if (!control) return;
    let value: string = (control.value || '').trim();
    if (!value) return;

    const lower = value.toLowerCase().replace(/\s/g, '');
    const dangerousSchemes = ['javascript:', 'data:', 'vbscript:'];
    if (dangerousSchemes.some(s => lower.startsWith(s))) {
      // Clear the value so the validator error shows cleanly
      control.setValue('');
      control.markAsTouched();
      this.urlSubmit = true;
      return;
    }

    // If no scheme present, prepend https://
    if (!value.match(/^https?:\/\//i)) {
      value = 'https://' + value;
      control.setValue(value);
    }
    control.markAsTouched();
  }

  /**
   * Trims leading and trailing whitespace from the Item Name field.
   * Called on blur so the stored value is normalised before the user
   * advances tabs or submits the form.
   */
  trimName(): void {
    const control = this.userBasicInfoForm.get('name');
    if (!control) return;
    const trimmed = (control.value || '').trim();
    if (trimmed !== control.value) {
      control.setValue(trimmed);
      // Keep itemAddModel in sync with the form control
      this.itemAddModel.name = trimmed;
    }
  }
  /**
     * To remove value from dropdowns
     */

  async removeDropdownValues(i, itemId, unit) {
    const dialogData = new ModalModel(
      this.translateService.instant('PROFILE.CONFIRMDELETE')
    );
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '450px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        const removeCustomValueSubs = this.itemsService
          .removeCustomValue({ id: itemId })
          .subscribe((val: any) => {
            if (unit == 'tax') {
              this.taxListArr.splice(i, 1);
            }
            if (unit == 'unit') {
              this.unitListArr.splice(i, 1);
            }
            // this.SuccessSnackBar('Measurement Removed', 'Ok');
          });
        this.subscriptions.push(removeCustomValueSubs);
      }
    });
  }


  /**
  * To add valuea in dropdowns.
  */
  addDropdownValue(addFormOfContact, categoryId) {

    if (!this.itemAddModel.categoryId && this.filterValue) {
      this.itemsService.categoryAdd({ name: this.filterValue, top_flag: 0 }).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.itemAddModel.categoryId = res.data.id
          this.categoryId = res.data.id
          this.userBasicInfoForm.get('categoryId').setValue(res.data.name)
          this.getCateogryList().then(() => {
            this._autoCompleteSearchControlForCategory()

          })
        }
      )

    } else {
      const dialogData: any = {};
      dialogData.addFormOfContact = addFormOfContact;
      dialogData.itemsEditButtonId = categoryId;
      dialogData.id = categoryId;
      const dialogRef = this.dialog.open(AddCategoryComponent, {
        width: "800px",
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(async (dialogResult) => {
        if (dialogResult.data) {
          this.itemAddModel.categoryId = dialogResult.data.id
          this.categoryId = dialogResult.data.id
          this.userBasicInfoForm.get('categoryId').setValue(dialogResult.data.name)
        }
        this.getCateogryList().then(() => {
          this._autoCompleteSearchControlForCategory()

        })
      });
    }


  }

  compareTaxObjects(o1: any, o2: any): boolean {
    if (!o1 || !o2) return o1 === o2;
    return o1.customValueId === o2.customValueId;
  }

  addDropdownValues(event, module, dropdown) {
    if (event == "addFormOfContact") {
      const dialogRef = this.dialog.open(AddValueInDropdownComponent, {
        width: "450px",
        data: { name: dropdown == 'taxes' ? 'Tax' : 'Unit' }
      });
      dialogRef.afterClosed().subscribe(async (dialogResult) => {
        if (dialogResult) {

          const nameExists = this.taxListArr?.some(item => item.name?.toLowerCase() === dialogResult?.name?.toLowerCase());
          if (nameExists) {
            this.snackbar.open(this.translateService.instant('QUOTE_TEMPLATE.Name_Exist'), this.translateService.instant('COMMON.OK'), { duration: 5000 });
            return;
          }
          const addCustomValueSubs = this.itemsService.addCustomValue({ name: dialogResult?.name, taxe_value: dialogResult?.percent, module_name: module, dropdown_name: dropdown }).subscribe((val: any) => {
            if (dropdown == 'taxes') {
              this.taxListArr = [...this.taxListArr, val];

              const selectedValue = {
                customValueId: val.id,
                name: val.name,
                complete: val,
              };

              // Auto-select the newly created tax in the Applicable Taxes dropdown.
              this.itemPriceTaxForm.get('taxData')?.setValue(selectedValue);

              // Auto-patch the new tax into the item's tax list (same action as selecting it from dropdown).
              this.onOptionSelected({ value: selectedValue });
            } if (dropdown == 'unit') {
              this.unitListArr.push(val);
            }
          });
          this.subscriptions.push(addCustomValueSubs);
        }
      });
    }
  }


  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.formulaDialogRef) {
      event.preventDefault();
      event.returnValue = true;
    }
  }

  ngOnDestroy(): void {
    this._destroyed = true;
    this.retireCustomFieldsViewSub();
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
    const openDialog = this.formulaDialogRef;
    this.formulaDialogRef = null;
    openDialog?.close();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  // Advane Unit Calculations 
  calculate() {
    // console.log("calculation data:",this.calculations);
    let result = 0;
    if (this.calculations.sign == '+') {
      result = this.calculations.height + this.calculations.width
    } else if (this.calculations.sign == "-") {
      result = this.calculations.height - this.calculations.width
    } else if (this.calculations.sign == "x") {
      result = this.calculations.height * this.calculations.width
    } else if (this.calculations.sign == "/") {
      result = this.calculations.height / this.calculations.width
    }
    if (result % 1 !== 0) this.calculations.result = result.toFixed(2);
    else this.calculations.result = result.toFixed(0);
  }

  //#region  Adding Custom Fields 
  editCustomFieldId = null;
  editCustomFieldIndex = null;
  valueFieldShow: any;
  addCustomFieldForm: FormGroup;
  fieldValueArr: any = [];
  customFieldListArr: any;
  checkedList = [];
  cusFieldFormSubmit = false;
  removable = true;
  customFieldDataArr: any = [];
  /** Recipes saved in the formula builder during this add/edit session, by field id. */
  private formulaRecipesThisSession = new Map<string, any>();
  /** Formula fields created during this session (Apply on quote defaults to on for this item). */
  private formulaFieldsCreatedThisSession = new Set<string>();
  customerFielsDataSubmit: any;
  // customDataFieldViewData = [];
  @ViewChild('customFieldForm') customFieldForm;
  customerCustomFieldArr = [];

  get customField(): { [key: string]: AbstractControl } {
    return this.addCustomFieldForm?.controls;
  }

  addToNgOninit() {
    this.addCustomFieldForm = this.formBuilder.group(
      {
        field_type_id: ['', Validators.required],
        name: [''],
        customer_custom_field_values: [''],
        order: ['']
      },
    );

    this.getAllListing();
  }

  addSubcategories(addFormOfContact, categoryId) {
    if (this.subCateogrySearch.value && !this.itemAddModel.subCategoryId) {
      if (this.categoryId) { this.subCategoryAddModel.categoryId = this.categoryId }
      if (!this.categoryId) {
        this.snackbar.open(this.translateService.instant('Snackbar.Please first select category'), this.translateService.instant('COMMON.Close'), {
          duration: 3000, // duration in milliseconds
          verticalPosition: 'top', // or 'bottom'
          horizontalPosition: 'center' // or 'left', 'right'
        });
        return
      }

      const addSubCateogrySubs = this.itemsService.addSubCateogry({ categoryId: this.categoryId || '', name: this.subCateogrySearch.value }).subscribe(
        res => {
          if (res.message === 'success' || res.status === 1) {
            if (res.data) {
              this.itemAddModel.subCategoryId = res.data.id
              this.subCategoryId = res.data.id
              this.userBasicInfoForm.get('subCategoryId').setValue(res.data.name)
            }
            this.getSubCategoryList();

          } else {
            this.spinnerService.hide();
          }
        });
      this.subscriptions.push(addSubCateogrySubs);
    } else {
      const dialogData: any = {};
      dialogData.categoryList = this.cateogryListArr;
      dialogData.categoryId = this.categoryId;
      const dialogRef = this.dialog.open(AddSubCategoryComponent, {
        width: "800px",
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(async (dialogResult) => {
        if (dialogResult) {
          if (dialogResult.data) {
            this.itemAddModel.subCategoryId = dialogResult.data.id
            this.subCategoryId = dialogResult.data.id
            this.userBasicInfoForm.get('subCategoryId').setValue(dialogResult.data.name)
          }
          this.getSubCategoryList();
        }

      });
    }





  }

  updateSubcategories(obj) {
    const dialogRef = this.dialog.open(AddSubCategoryComponent, {
      width: "800px",
      data: obj
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        this.userBasicInfoForm.patchValue({
          subCategoryId: dialogResult?.data?.name
        })
        this.getSubCategoryList();
      }

    });
  }

  async removeSubCategory(i, subCategoryId, obj) {
    const dialogData = new ModalModel(
      this.translateService.instant('PROFILE.CONFIRMDELETE')
    );
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '450px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        const removeSubCategoryValueSubs = this.itemsService
          .removeSubCategoryValue({ id: subCategoryId })
          .subscribe((val: any) => {
            if (obj == 'Subcategory') {
              this.subCategoryListArr.splice(i, 1);
              this._autoCompleteSearchControlForSubCategory()
              // this.getSearchHistory().then((res: any) => {
              //   this.categorySearchHistory = res;
              //   this.infoItemBlock = false;
              //   this.hiddenInfo = true;
              // });
            }
            // this.SuccessSnackBar('Measurement Removed', 'Ok');
          });
        this.subscriptions.push(removeSubCategoryValueSubs);
      }
    });
  }

  deleteCustomField(data) {

    // this.itemsService.itemcustomFieldList({ module: 'organization' }).subscribe(result => {
    //   this.fieldListingDataId = result.data[0] ? result.data[0].id : '';
    //   if (result.data.length > 0) {
    //     if (result.data[0]?.field.length < 1 || result.data[0]?.field == '[]') {
    //       this.fieldListArr = [];
    //     } else {
    //       this.fieldListArr = result.data[0]?.field;
    //     }
    //   }
    //   const index = this.fieldListArr.findIndex(val => val == data?.customField?.name);
    //   this.fieldListArr.splice(index, 1);
    //   this.filterDataJson = { field: this.fieldListArr, id: this.fieldListingDataId, module: 'organization' };
    // Resolve the row by the id captured now, not the index: the list can be reordered or
    // replaced while the request is in flight.
    const fieldId = data?.customField?.id;
    this.itemsService.deleteCustomField({ id: fieldId }).pipe(takeUntil(this.ensureUnsubscribeSubject())).subscribe({
      next: () => {
        const index = (this.customerCustomFieldArr || []).findIndex((f) => String(f?.id) === String(fieldId));
        if (index > -1) {
          this.customerCustomFieldArr.splice(index, 1);
        }
        // The cached field list (formulas + the flat-name allowlist) no longer matches.
        this.formulaRuntime.invalidateCache();
      },
      error: (err) => {
        // The interceptor owns the user-facing message; retain diagnostic context.
        this.logger.log('items:deleteCustomField failed', err?.message || 'delete failed');
      },
    });
  }

  private parseFormulaMoney(raw: any): number | null {
    if (raw === undefined || raw === null || String(raw).trim() === '') {
      return null;
    }
    const n = parseFloat(String(raw).replace(/,/g, '').replace(/[^0-9.-]/g, ''));
    return Number.isFinite(n) ? n : null;
  }

  private buildFormulaItemContext(): Record<string, number> {
    const context: Record<string, number> = {};
    const qtyRaw = this.numberField?.get('numberValue')?.value;
    const qty = qtyRaw === undefined || qtyRaw === null || qtyRaw === ''
      ? null
      : Number(qtyRaw);
    if (qty != null && Number.isFinite(qty)) {
      context['Item.Quantity'] = qty;
    }

    const priceA = this.parseFormulaMoney(this.itemPriceForm?.get('pricesA')?.value);
    const priceB = this.parseFormulaMoney(this.itemPriceForm?.get('pricesB')?.value);
    const priceC = this.parseFormulaMoney(this.itemPriceForm?.get('pricesC')?.value);
    const priceD = this.parseFormulaMoney(this.itemPriceForm?.get('pricesD')?.value);
    if (priceA != null) {
      context['Item.Price_A'] = priceA;
      context['Item.Unit_Price'] = priceA;
    }
    if (priceB != null) {
      context['Item.Price_B'] = priceB;
    }
    if (priceC != null) {
      context['Item.Price_C'] = priceC;
    }
    if (priceD != null) {
      context['Item.Price_D'] = priceD;
    }
    if (qty != null && Number.isFinite(qty) && priceA != null) {
      context['Item.Total'] = qty * priceA;
    }

    const firstDiscount = Number(this.addDiscountsArr?.[0]?.discounts);
    if (Number.isFinite(firstDiscount)) {
      context[DISCOUNT_PERCENT_TOKEN] = Math.min(100, Math.max(0, firstDiscount));
    }

    const formValues = this.getCustomFieldFormValues();
    for (const field of this.customerCustomFieldArr || []) {
      if (!isNumberType(field?.field_type_id)) {
        continue;
      }
      const parsed = this.parseFormulaMoney(formValues['value_' + field.id]);
      if (parsed == null) {
        continue;
      }
      const variable = variableFromCustomField(field);
      if (variable) {
        context[variable.id] = parsed;
      }
    }
    return context;
  }

  getExistingCustomFieldNames(excludeName?: string): string[] {
    return (this.customerCustomFieldArr || [])
      .map((field) => String(field?.name || '').trim())
      .filter((name) => name && name.toLowerCase() !== String(excludeName || '').trim().toLowerCase());
  }

  getAllListing() {

    const customerCustomFieldListSubs = this.itemsService.customerCustomFieldList({ hideLoader: true }).subscribe((val: any) => {
      this.customerCustomFieldArr = val.data;
      this.notifyCustomFieldDataReady('definitions');
    });
    this.subscriptions.push(customerCustomFieldListSubs);

    const customFieldListSubs = this.editContactService.customFieldList({ hideLoader: true }).subscribe((val: any) => {
      this.customFieldListArr = val.data;
    });
    this.subscriptions.push(customFieldListSubs);
  }

  editCustomField(event) {
    this.editCustomFieldId = event.customField?.id;
    this.editCustomFieldIndex = event?.index;
    this.valueFieldShow = event.customField?.field_type_id;

    if (isFormulaType(event.customField?.field_type_id)) {
      this.openFormulaBuilder({
        editMode: true,
        name: event.customField?.name,
        // Only a field already saved as Formula keeps an older name unchecked (card #553).
        savedName: event.customField?.name,
        unit_of_measure: event.customField?.unit_of_measure,
        field_key: event.customField?.field_key,
        execution_order: event.customField?.execution_order,
        // Card #718: a product with no recipe of its own opens on the field's own formula (set in
        // Settings), never on the empty "Quantity x" start that Save would then store.
        formula_json: event.customField?.item_formula_json || fieldOwnFormula(event.customField) || undefined,
        existingNames: this.getExistingCustomFieldNames(event.customField?.name),
      });
      return;
    }

    this.addCustomFieldForm.patchValue(event.customField)
    this.fieldValueArr = event.customField?.customer_custom_field_values || [];
    this.isCustomBackground = true;
    this.toggleCustomFieldModal(true);
  }

  closeCustomFieldDialog() {
    this.valueFieldShow = null;
    this.fieldValueArr = [];
    this.editCustomFieldId = null;
    this.editCustomFieldIndex = null;
    this.addCustomFieldForm.reset();
    this.isCustomBackground = false
  }

  chnageType(event: any) {
    this.valueFieldShow = event.value;
    if (isFormulaType(event.value)) {
      this.toggleCustomFieldModal(false);
      this.openFormulaBuilder({
        editMode: !!this.editCustomFieldId,
        name: String(this.addCustomFieldForm.get('name')?.value || '').trim(),
        existingNames: this.getExistingCustomFieldNames(),
      });
    }
  }

  private toggleCustomFieldModal(show: boolean): void {
    const modalElement = document.getElementById('add_custom_field');
    if (!modalElement || typeof bootstrap === 'undefined' || !bootstrap?.Modal) {
      this.logger.log('warn: Bootstrap modal unavailable');
      this.snackbar.open(
        this.translateService.instant('COMMON.Something went wrong'),
        this.translateService.instant('COMMON.Close'),
        { duration: 4000 },
      );
      return;
    }
    const modalInstance =
      bootstrap.Modal.getOrCreateInstance?.(modalElement) ||
      bootstrap.Modal.getInstance?.(modalElement) ||
      new bootstrap.Modal(modalElement);
    if (!modalInstance) {
      return;
    }
    if (show) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
  }

  openFormulaBuilder(data: any = {}) {
    if (this._destroyed) {
      return;
    }
    // A second open (double click on Edit) would orphan the first ref and its afterClosed would
    // null the second's, switching off the unsaved-changes guard.
    if (this.formulaDialogRef) {
      return;
    }
    this.formulaDialogRef = this.dialog.open(FormulaBuilderDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      panelClass: 'formula-builder-dialog-panel',
      disableClose: true,
      data: {
        ...data,
        availableCustomFields: [...(this.customerCustomFieldArr || [])],
        itemContext: this.buildFormulaItemContext(),
      },
    });
    const stop$ = this.ensureUnsubscribeSubject();
    this.formulaDialogRef.afterClosed()
      .pipe(take(1), takeUntil(stop$))
      .subscribe((result) => {
        this.formulaDialogRef = null;
        if (this._destroyed) {
          return;
        }
        if (!result) {
          this.closeCustomFieldDialog();
          return;
        }
        this.saveFormulaCustomField(result);
      });
  }

  saveFormulaCustomField(payload: any) {
    if (this._destroyed) {
      return;
    }
    const stop$ = this.ensureUnsubscribeSubject();
    const itemId = this.inputData?.id;
    const requestPayload = itemId ? { ...payload, item_id: itemId } : payload;

    // Captured before the request: the response must land on the field that was edited, even if the
    // list was reordered or edit state changed meanwhile.
    const editId = this.editCustomFieldId;
    if (editId) {
      // A product not saved yet has no id. Sending its recipe without item_id made the server write
      // it into the FIELD's shared formula, changing the formula for every product. Keep the recipe
      // in this session instead (formulaRecipesThisSession, below); it is posted with the product.
      // The server keeps the field's formula when formula_json is absent.
      let updatePayload = requestPayload;
      if (!itemId) {
        const { formula_json: _sessionRecipe, ...fieldOnly } = requestPayload;
        updatePayload = fieldOnly;
      }
      this.itemsService
        .updateItemCustomfield(editId, updatePayload)
        .pipe(takeUntil(stop$))
        .subscribe({
          next: (res) => {
            if (this._destroyed) {
              return;
            }
            if (res?.message == 'success' || res?.status === 1) {
              this.formulaRuntime.invalidateCache();
              const index = (this.customerCustomFieldArr || []).findIndex((f) => String(f?.id) === String(editId));
              if (index > -1) {
                const _customerCustomFieldArr = [...this.customerCustomFieldArr];
                _customerCustomFieldArr[index] = this.mergeUpdatedCustomField(
                  this.customerCustomFieldArr[index],
                  { ...res.data, item_formula_json: payload.formula_json },
                );
                this.customerCustomFieldArr = _customerCustomFieldArr;
              }
              this.formulaRecipesThisSession.set(String(editId), payload.formula_json);
              this.rememberItemFormulaJson(editId, payload.formula_json);
              this.clearCopiedFormulaNotice(editId);
              this.closeCustomFieldDialog();
            }
          },
          error: (err) => {
            this.logger.log('formula:saveCustomField update error', err?.message || 'update failed');
            if (!this._destroyed) {
              this.showFormulaSaveError();
            }
          },
        });
      return;
    }

    payload.order = (this.customerCustomFieldArr?.length ?? 0) + 1;
    const createPayload = itemId ? { ...payload, item_id: itemId } : payload;
    this.itemsService.createCustomField(createPayload)
      .pipe(takeUntil(stop$))
      .subscribe({
        next: (res) => {
          if (this._destroyed) {
            return;
          }
          if (res?.message == 'success' || res?.status === 1) {
            this.formulaRuntime.invalidateCache();
            const _customerCustomFieldArr = [...(this.customerCustomFieldArr || [])];
            _customerCustomFieldArr.push({
              ...res.data,
              item_formula_json: payload.formula_json,
              apply_formula: true,
            });
            this.customerCustomFieldArr = _customerCustomFieldArr;
            if (res.data?.id) {
              this.formulaRecipesThisSession.set(String(res.data.id), payload.formula_json);
              this.formulaFieldsCreatedThisSession.add(String(res.data.id));
              this.rememberItemFormulaJson(res.data.id, payload.formula_json);
            }
            this.closeCustomFieldDialog();
          }
        },
        error: (err) => {
          this.logger.log('formula:saveCustomField create error', err?.message || 'create failed');
          if (!this._destroyed) {
            this.showFormulaSaveError();
          }
        },
      });
  }

  /**
   * The translate key of a custom field TYPE name. "Number" gets its own key: COMMON.Number is the
   * phone/quote "Number" elsewhere (FR "Numéro"), while the field type means a quantity (FR "Nombre").
   */
  customFieldTypeKey(name: unknown): string {
    const type = String(name ?? '');
    return type === 'Number' ? 'COMMON.Number field type' : 'COMMON.' + type;
  }

  private showFormulaSaveError(): void {
    this.snackbar.open(
      this.translateService.instant('COMMON.Calculation save failed'),
      this.translateService.instant('COMMON.Close'),
      { duration: 3000 },
    );
  }

  add1(event: MatChipInputEvent): void {
    const input = event.input;
    const rawValue = event.value || '';
    const value = rawValue.trim();
    const disallowedChars = ['-', '/'];
    const currentValueFieldShow = this.valueFieldShow;

    // Check for invalid characters
    if ([2, 4, 5].includes(currentValueFieldShow) && disallowedChars.some(char => value.includes(char))) {
      this.snackbar.open(
        this.translateService.instant('QUOTE_TEMPLATE.chacraters'),
        this.translateService.instant('COMMON.OK'),
        { duration: 5000 }
      )

      // Clear the chip input box manually
      if (input) {
        input.value = '';
      }

      // Exit early – don't push to arrays
      return;
    }


    // Valid input – proceed to push
    if (value) {
      this.checkedList.push({ value: '', customerCustomFieldId: '' });
      this.fieldValueArr.push({ value });
    }

    // Clear the input field
    if (input) {
      input.value = '';
    }
  }



  remove1(fruit): void {
    const index = this.fieldValueArr.indexOf(fruit);
    if (index >= 0) {
      this.checkedList.splice(index, 1)
      this.fieldValueArr.splice(index, 1);
    }
  }

  /**
   * A Number field's name becomes a formula variable (Item.Custom.<Name>), so it follows the
   * builder's rules: required, not a reserved quote column, letters/digits/spaces/- _ ( ) only
   * (cards #519 / #522: "Qty", "Price", "" and "width----23232323" all saved with no check).
   */
  get customFieldNameError(): string {
    const edited = (this.customerCustomFieldArr || []).find((f) => String(f?.id) === String(this.editCustomFieldId));
    const typeId = String(this.addCustomFieldForm?.value?.field_type_id || edited?.field_type_id || '');
    if (!isNumberType(typeId)) {
      return '';
    }
    const name = String(this.addCustomFieldForm?.value?.name || '').trim();
    if (!name) {
      return this.translateService.instant('COMMON.Field name is required');
    }
    // Editing an older Number field without renaming it: its name may predate the rules; leave it.
    // A field of another type switched to Number is new to the rules, so it is checked (card #553).
    if (edited && isNumberType(edited?.field_type_id) && name === String(edited?.name || '').trim()) {
      return '';
    }
    if (name.length > 50) {
      return this.translateService.instant('COMMON.Field name max 50');
    }
    if (isReservedFieldName(name)) {
      return this.translateService.instant('COMMON.Formula field name reserved named', {
        name,
        list: RESERVED_NAMES_SHOWN.join(', '),
      });
    }
    if (!passesFieldNameRule(name)) {
      return this.translateService.instant('COMMON.Field name characters');
    }
    return '';
  }

  addCustomFieldList() {
    this.cusFieldFormSubmit = true
    if (this.addCustomFieldForm.invalid || this.customFieldNameError) {
      return
    } else {
      this.addCustomFieldForm?.controls['customer_custom_field_values'].setValue(this.fieldValueArr)
      if (this.editCustomFieldId) {
        // Captured before the request: the response lands on the edited field, found by id, even if
        // the list was reordered (or edit state changed) while it was in flight.
        const editId = this.editCustomFieldId;
        const updateCustomFieldSubs = this.itemsService.updateItemCustomfield(editId, this.addCustomFieldForm.value).subscribe((res) => {
          if (res.message == 'success' || res.status === 1) {
            this.fieldValueArr = [];
            this.addCustomFieldForm.reset();
            const index = (this.customerCustomFieldArr || []).findIndex((f) => String(f?.id) === String(editId));
            if (index > -1) {
              const _customerCustomFieldArr = [...this.customerCustomFieldArr];
              _customerCustomFieldArr[index] = this.mergeUpdatedCustomField(
                this.customerCustomFieldArr[index],
                res.data,
              );
              this.customerCustomFieldArr = _customerCustomFieldArr;
            }
            this.formulaRuntime.invalidateCache(); // a renamed field changes the formula allowlist
            this.cusFieldFormSubmit = false
            this.customFieldForm.nativeElement.click();
            this.editCustomFieldIndex = null;
            this.editCustomFieldId = null;
          }
        })
        this.subscriptions.push(updateCustomFieldSubs);
      } else {
        this.addCustomFieldForm?.controls['order'].setValue(this.customerCustomFieldArr.length + 1);
        const addCustomFieldSubs = this.itemsService.createCustomField(this.addCustomFieldForm.value).subscribe((res) => {
          if (res.message == 'success' || res.status === 1) {
            this.fieldValueArr = [];
            this.addCustomFieldForm.reset();
            const _customerCustomFieldArr = [...(this.customerCustomFieldArr || [])];
            _customerCustomFieldArr.push(res.data);
            this.customerCustomFieldArr = _customerCustomFieldArr;
            this.formulaRuntime.invalidateCache(); // a new Number field is a new formula input
            // this.getAllListing();          
            this.cusFieldFormSubmit = false
            this.customFieldForm.nativeElement.click();
          }
        })
        this.subscriptions.push(addCustomFieldSubs);
      }

    }
    this.isCustomBackground = false
  }

  onOptionSelected(event: any) {
    const selectedValue = event.value;
    if (selectedValue) {
      const addCustomFieldSubs = this.itemsService.itemTexValues({ customValueId: selectedValue?.customValueId }).subscribe((res) => {
        const newItem = res?.results[0]; // Extract the first item from the received array
        this.addItemPriceTax(selectedValue?.complete)

      });
      this.subscriptions.push(addCustomFieldSubs);
    }
  }

  editDropdownValues(dropdownValue) {
    const dialogRef = this.dialog.open(AddValueInDropdownComponent, {
      width: "450px",
      data: { name: 'Tax', editValues: dropdownValue }
    });
    dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {

        const editCustomValueSubs = this.itemsService.addCustomValue({ id: dropdownValue?.id, name: dialogResult?.name, taxe_value: dialogResult?.percent }).subscribe((val: any) => {
          this.getTaxList()
        });
        this.subscriptions.push(editCustomValueSubs);
      }
    });
  }
  openBulkActionPopup(event, i) {
    this.currentIndex = i
    event.stopPropagation();

    this.cateogryListArr.map((x, index) => {
      if (i === index) {
        this.openBulkAction = !this.openBulkAction;
      }
    });
  }

  closingbulkdialog() {

    this.openBulkAction = false;
  }

  getTranslatedText(key: string): string {
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  getSelectedTabIndex(): number {
    switch (this.languageName) {
      case 'English':
        return 0; // Select English tab
      case 'Spanish':
        return 1; // Select Spanish tab
      case 'French':
        return 2; // Select French tab
      default:
        return 0; // Default to English if no match
    }
  }

  /**
   * Initialize expansion panel states based on selected tab
   */
  initializeExpansionPanels(): void {
    const selectedIndex = this.getSelectedTabIndex();
    this.englishPanelExpanded = selectedIndex === 0;
    this.spanishPanelExpanded = selectedIndex === 1;
    this.frenchPanelExpanded = selectedIndex === 2;

    // Ensure form controls have default values before the editor initializes
    this.ensureFormControlValues();
  }

  /**
   * Ensure form control values are initialized
   */
  ensureFormControlValues(): void {
    if (this.userBasicInfoForm) {
      const descriptionControl = this.userBasicInfoForm.get('description');
      const descriptionEsControl = this.userBasicInfoForm.get('description_es');
      const descriptionFrControl = this.userBasicInfoForm.get('description_fr');

      if (descriptionControl && (descriptionControl.value === null || descriptionControl.value === undefined)) {
        descriptionControl.setValue('');
      }
      if (descriptionEsControl && (descriptionEsControl.value === null || descriptionEsControl.value === undefined)) {
        descriptionEsControl.setValue('');
      }
      if (descriptionFrControl && (descriptionFrControl.value === null || descriptionFrControl.value === undefined)) {
        descriptionFrControl.setValue('');
      }
    }
  }

  /**
   * Check if form control exists and is ready
   */
  isFormControlReady(controlName: string): boolean {
    if (!this.userBasicInfoForm) {
      return false;
    }
    const control = this.userBasicInfoForm.get(controlName);
    if (!control) {
      return false;
    }
    // Ensure value is not null/undefined before the editor initializes
    if (control.value === null || control.value === undefined) {
      control.setValue('');
    }
    return true;
  }

  onInputChange(event: any): void {
    const raw = event?.target?.value;
    // Allow the field to be CLEARED while typing so the user can delete the current
    // value and enter a new one (e.g. 5). Previously any empty value made Number('')
    // === 0, which forced the field back to 1 on every keystroke, so the existing
    // digit could never be removed. Only coerce an explicit 0 here; an empty field is
    // normalized to 1 on blur.
    if (raw !== '' && raw !== null && raw !== undefined && Number(raw) === 0) {
      this.numberField.get('numberValue').setValue(1);
    }
  }

  // Normalize the "Quantity per click" field when the user leaves it: an empty or
  // invalid value becomes 1 (the minimum), so a freshly-cleared field never saves blank.
  onQtyPerClickBlur(): void {
    const ctrl = this.numberField.get('numberValue');
    const value = Number(ctrl?.value);
    if (ctrl?.value === '' || ctrl?.value === null || ctrl?.value === undefined || isNaN(value) || value < 1) {
      ctrl.setValue(1);
    }
  }
  isCustomBackground = false
  openCustom() {
    this.isCustomBackground = true
  }
}
